import Layout from "../components/Layouts";
import Nav from "../components/Navi";
import Footer from "../components/Footers";
import CountdownBar from "../components/CountdownBar";
import React from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
export default function Terms() {
  const { t } = useTranslation("common");

  return (
    <>
      <div className="page-default">

      <div className="container mt-5">
        {/* <div className="pos" id="_0:0" style={{top: 0}}> */}
          {/* <img name="_1170:828" src="page_001.jpg" height={1170} width={828} border={0} useMap="#Map" /></div> */}
        {/* <div className="pos" id="_28:16" style={{top: 16, left: 28}}>
          <span id="_14.7" style={{ fontSize: '14.7px', color: '#007f00'}}>
            SC Classification:GENERAL BUSINESS\Other General Business</span>
        </div> */}
        <div className="pos text-center mb-3" id="_376:116" style={{top: 116, left: 376}}>
          <span id="_18.5" className="text-decoration-underline" style={{fontWeight: 'bold',  fontSize: '22.5px', color: '#000000'}}>
            HAYYA MEDIA PORTAL</span>
        </div>
        <div className="pos text-center mb-5" id="_368:140" style={{top: 140, left: 368}}>
          <span id="_18.5" style={{fontWeight: 'bold',  fontSize: '22.5px', color: '#000000'}}>
            <u>T</u><u>E</u><u>R</u><u>M</u><u>S</u><u> </u><u>A</u><u>N</u><u>D</u><u> </u><u>C</u><u>O</u><u>N</u><u>D</u><u>I</u><u>T</u><u>I</u><u>O</u><u>N</u><u>S</u></span>
        </div>
        <div className="pos" id="_91:204" style={{top: 204, left: 91}}>
          <span id="_15.0" style={{fontWeight: 'bold',  fontSize: '15.0px', color: '#000000'}}>
            1.</span>
        </div>
        <div className="pos" id="_141:204" style={{top: 204, left: 141}}>
          <span id="_18.5" style={{fontWeight: 'bold',  fontSize: '18.5px', color: '#000000'}}>
            Purpose and Scope</span>
        </div>
        <div className="pos" id="_91:235" style={{top: 235, left: 91}}>
          <span id="_14.1" style={{ fontSize: '13.8px', color: '#000000'}}>
            The following HMP Terms are designed to govern the process to allow Media to apply on the Hayya Media Portal </span>
          <span id="_15.0" style={{ fontSize: '15.0px', color: '#000000'}}>
            for:</span>
        </div>
        <div className="pos" id="_116:287" style={{top: 287, left: 116}}>
          <span id="_14.2" style={{ fontSize: '14.2px', color: '#000000'}}>
            a) A Hayya ID, to permit the Applicant to enter the State of Qatar; </span>
        </div>
        <div className="pos" id="_116:307" style={{top: 307, left: 116}}>
          <span id="_14.2" style={{ fontSize: '14.2px', color: '#000000'}}>
            b) Accreditation in respect of the Event; </span>
        </div>
        <div className="pos" id="_116:327" style={{top: 327, left: 116}}>
          <span id="_14.2" style={{ fontSize: '14.2px', color: '#000000'}}>
            c) Filming Permit for the purpose of the Event; and </span>
        </div>
        <div className="pos" id="_116:347" style={{top: 347, left: 116}}>
          <span id="_13.8" style={{ fontSize: '14.2px', color: '#000000'}}>
            d) To access other HMP Services.</span>
        </div>
        <div className="pos" id="_91:387" style={{top: 387, left: 91}}>
          <span id="_15.0" style={{fontWeight: 'bold',  fontSize: '15.0px', color: '#000000'}}>
            2.</span>
        </div>
        <div className="pos" id="_141:387" style={{top: 387, left: 141}}>
          <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000000'}}>
            Definitions</span>
        </div>
        <div className="pos" id="_91:419" style={{top: 419, left: 91}}>
          <span id="_14.0" style={{ fontSize: '14.0px', color: '#000000'}}>
            The following definitions shall be used in these HMP Terms:</span>
        </div>
        <div className="pos" id="_91:450" style={{top: 450, left: 91}}>
          <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000000'}}>
            SC, we or us<span style={{fontWeight: 'normal'}}> means the Supreme Committee for Delivery &amp; Legacy, an entity established under the laws of the </span></span>
          <span id="_14.0" style={{ fontSize: '14.0px', color: '#000000'}}>
            State of Qatar pursuant to Emiri Decree No. 69 of 2024, and its successors and assigns.</span>
        </div>
        <div className="pos" id="_91:501" style={{top: 501, left: 91}}>
          <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000000'}}>
            You, the Applicant,<span style={{fontWeight: 'normal'}}> means any person who makes an Application on the Hayya Media Portal.</span></span>
        </div>
        <div className="pos" id="_91:532" style={{top: 532, left: 91}}>
          <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000000'}}>
            Accreditation <span style={{fontWeight: 'normal'}}> means an individual and non-transferable right of access to the whole or part of a site intended to </span></span>
          <span id="_14.0" style={{ fontSize: '14.0px', color: '#000000'}}>
            be used as an accredited site for the purposes of the Event, issued in in accordance with the Accreditation Terms<span style={{fontWeight: 'bold'}}> .</span></span>
        </div>
        <div className="pos" id="_91:584" style={{top: 584, left: 91}}>
          <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000000'}}>
            Accreditation Terms<span style={{fontWeight: 'normal'}}> </span><span style={{fontWeight: 'normal'}}> means the terms and conditions for issue and use of an Accreditation, which can be found at </span></span>
          <span id="_14.0" style={{ fontSize: '14.0px', color: '#000000'}}>
            Appendix 2 to these Terms. </span>
        </div>
        <div className="pos" id="_91:635" style={{top: 635, left: 91}}>
          <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000000'}}>
            Application <span style={{fontWeight: 'normal'}}> means an application on the Hayya Media Portal in accordance with these HMP Terms to access HMP </span></span>
          <span id="_15.0" style={{ fontSize: '15.0px', color: '#000000'}}>
            Services.</span>
        </div>
        <div className="pos" id="_91:687" style={{top: 687, left: 91}}>
          <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000000'}}>
            Application Data<span style={{fontWeight: 'normal'}}> means all data you submit as part of your Application or any Application for another person which </span></span>
          <span id="_14.0" style={{ fontSize: '14.0px', color: '#000000'}}>
            you are permitted to make.</span>
        </div>
        <div className="pos" id="_91:738" style={{top: 738, left: 91}}>
          <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000000'}}>
            Event<span style={{fontWeight: 'normal'}}> means the FIFA Intercontinental Cup 2024TM.</span></span>
        </div>
        <div className="pos" id="_91:769" style={{top: 769, left: 91}}>
          <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000000'}}>
            Filming Permit<span style={{fontWeight: 'normal'}}> means a permit to allow the Applicant to create photography and/or film at certain locations in the </span></span>
          <span id="_14.0" style={{ fontSize: '14.0px', color: '#000000'}}>
            State of Qatar for the purpose of the Event, in accordance with the Filming Permit Terms.</span>
        </div>
        <div className="pos" id="_91:820" style={{top: 820, left: 91}}>
          <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000000'}}>
            Filming Permit Terms<span style={{fontWeight: 'normal'}}> means the terms and conditions for issue and use of a Filming Permit, which can be found at </span></span>
          <span id="_14.0" style={{ fontSize: '14.0px', color: '#000000'}}>
            Appendix 3 to these HMP Terms<span style={{fontWeight: 'bold'}}> .</span></span>
        </div>
        <div className="pos" id="_91:872" style={{top: 872, left: 91}}>
          <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000000'}}>
            Hayya ID<span style={{fontWeight: 'normal'}}> </span><span style={{fontWeight: 'normal'}}> means the digital identity issued to a successful Applicant to allow entry into the State of Qatar, issued in </span></span>
          <span id="_14.0" style={{ fontSize: '14.0px', color: '#000000'}}>
            accordance with the Hayya Terms.</span>
        </div>
        <div className="pos" id="_91:923" style={{top: 923, left: 91}}>
          <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000000'}}>
            Hayya Terms <span style={{fontWeight: 'normal'}}> means the terms and conditions for issue and use of a Hayya ID, which can be found at Appendix 1 </span></span>
          <span id="_14.0" style={{ fontSize: '14.0px', color: '#000000'}}>
            to these HMP Terms.</span>
        </div>
        <div className="pos" id="_91:975" style={{top: 975, left: 91}}>
          <span id="_14.5" style={{fontWeight: 'bold',  fontSize: '14.5px', color: '#000000'}}>
            Hayya Media Portal (HMP)<span style={{fontWeight: 'normal'}}> means the website owned by SC through which Media can apply for accreditation </span></span>
          <span id="_14.5" style={{ fontSize: '14.5px', color: '#000000'}}>
            and/or  permits  to  cover  a  given  Event  and  have  access  to  media  content  and  services,  and  which  is  hosted </span>
          <span id="_14.5" style={{ fontSize: '14.5px', color: '#000000'}}>
            at <a href="http://media.hayya.qa">http://media.hayya.qa</a></span>
        </div>
        <div className="pos" id="_91:1046" style={{top: 1046, left: 91}}>
          <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000000'}}>
            HMP Mobile App<span style={{fontWeight: 'normal'}}> means the mobile app (if any) launched by SC to support provision of the HMP Services.</span></span>
        </div>
        <div className="pos" id="_91:1281" style={{top: 1281, left: 91}}>
          <span id="_14.1" style={{fontWeight: 'bold',  fontSize: '13.8px', color: '#000000'}}>
            HMP Services<span style={{fontWeight: 'normal'}}> means the full range of services offered to Media who’s Application is successful, including, but not </span></span>
          <span id="_14.1" style={{ fontSize: '13.8px', color: '#000000'}}>
            limited to, provision of:</span>
        </div>
        <div className="pos" id="_119:1331" style={{top: 1331, left: 119}}>
          <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
          •<span id="_14.1" style={{ fontSize: '14.1px'}}> Hayya ID</span></span>
        </div>
        <div className="pos" id="_119:1352" style={{top: 1352, left: 119}}>
          <span id="_13.6" style={{  color: '#000000'}}>
          •<span id="_14.8" style={{ fontSize: '14.8px'}}> Accreditation</span></span>
        </div>
        <div className="pos" id="_119:1373" style={{top: 1373, left: 119}}>
          <span id="_13.6" style={{  color: '#000000'}}>
          •<span id="_14.8" style={{ fontSize: '14.8px'}}> Filming Permit</span></span>
        </div>
        <div className="pos" id="_91:1406" style={{top: 1406, left: 91}}>
          <span id="_14.0" style={{ fontSize: '14.0px', color: '#000000'}}>
            as well as exclusive access to media content.</span>
        </div>
        <div className="pos" id="_91:1437" style={{top: 1437, left: 91}}>
          <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000000'}}>
            HMP Terms<span style={{fontWeight: 'normal'}}> means these terms of use for the Hayya Media Portal.</span></span>
        </div>
        <div className="pos" id="_91:1468" style={{top: 1468, left: 91}}>
          <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000000'}}>
            Indemnified Entities<span style={{fontWeight: 'normal'}}> has the definition set out in Clause 9 of these HMP Terms.</span></span>
        </div>
        <div className="pos" id="_91:1500" style={{top: 1500, left: 91}}>
          <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000000'}}>
            Media<span style={{fontWeight: 'normal'}}> means all media representatives including, but not limited to, written press, web based media, TV and radio </span></span>
          <span id="_14.0" style={{ fontSize: '14.0px', color: '#000000'}}>
            journalists, technicians, photographers and social media influencers.</span>
        </div>
        <div className="pos" id="_91:1551" style={{top: 1551, left: 91}}>
          <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000000'}}>
            Privacy Policy<span style={{fontWeight: 'normal'}}> means the SC’s privacy policy which governs the collection of data on the Hayya Media Portal and </span></span>
          <span id="_14.0" style={{ fontSize: '14.0px', color: '#000000'}}>
            can be found at <u>h</u><u>t</u><u>t</u><u>p</u><u>s</u><u>:</u><u>/</u><u>/</u><u>m</u><u>e</u><u>d</u><u>i</u><u>a</u><u>.</u><u>h</u><u>a</u><u>y</u><u>y</u><u>a</u><u>.</u><u>q</u><u>a</u><u>/</u><u>p</u><u>r</u><u>i</u><u>v</u><u>a</u><u>c</u><u>y</u><u>-</u><u>p</u><u>o</u><u>l</u><u>i</u><u>c</u><u>y</u>.</span>
        </div>
        <div className="pos" id="_91:1602" style={{top: 1602, left: 91}}>
          <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000000'}}>
            2. Acceptance of Terms</span>
        </div>
        <div className="pos" id="_91:1634" style={{top: 1634, left: 91}}>
          <span id="_14.0" style={{ fontSize: '14.0px', color: '#000000'}}>
            2.1 These HMP Terms set out the process by which a HMP Application can be made, the basis upon which SC will </span>
          <span id="_14.0" style={{ fontSize: '14.0px', color: '#000000'}}>
            process such HMP Application, and the terms for use of the HMP by a successful Applicant.</span>
        </div>
        <div className="pos" id="_91:1685" style={{top: 1685, left: 91}}>
          <span id="_14.5" style={{ fontSize: '14.5px', color: '#000000'}}>
            2.2 Before submitting an HMP Application, you should ensure that you have read and understood these HMP </span>
          <span id="_15.0" style={{ fontSize: '15.0px', color: '#000000'}}>
            Terms.</span>
        </div>
        <div className="pos" id="_91:1737" style={{top: 1737, left: 91}}>
          <span id="_14.1" style={{ fontSize: '13.8px', color: '#000000'}}>
            2.3 By using or otherwise accessing the HMP Services, or clicking to accept or agree to these HMP Terms where </span>
          <span id="_14.1" style={{ fontSize: '13.8px', color: '#000000'}}>
            that option is made available, you:</span>
        </div>
        <div className="pos" id="_91:1788" style={{top: 1788, left: 91}}>
          <span id="_14.1" style={{ fontSize: '13.8px', color: '#000000'}}>
            (a) accept and agree to these HMP Terms and any additional policies which relate to the HMP Services.</span>
        </div>
        <div className="pos" id="_91:1819" style={{top: 1819, left: 91}}>
          <span id="_14.1" style={{ fontSize: '13.8px', color: '#000000'}}>
            (b) consent to the collection, use, disclosure and other handling of information as described in our Privacy Policy.</span>
        </div>
        <div className="pos" id="_91:1850" style={{top: 1850, left: 91}}>
          <span id="_14.1" style={{ fontSize: '13.8px', color: '#000000'}}>
            (c) agree to any additional terms, rules and conditions as may be issued by SC from time to time in relation to the </span>
          <span id="_14.1" style={{ fontSize: '13.8px', color: '#000000'}}>
            use of the Hayya Media Portal.</span>
        </div>
        <div className="pos" id="_91:1902" style={{top: 1902, left: 91}}>
          <span id="_14.1" style={{fontWeight: 'bold',  fontSize: '13.8px', color: '#000000'}}>
            3. Modification of Terms</span>
        </div>
        <div className="pos" id="_91:1933" style={{top: 1933, left: 91}}>
          <span id="_14.1" style={{ fontSize: '13.8px', color: '#000000'}}>
            SC reserves the right, at its sole discretion, to modify or replace these HMP Terms at any time. Updated versions </span>
          <span id="_14.1" style={{ fontSize: '13.8px', color: '#000000'}}>
            of these HMP Terms will be posted on the Hayya Media Portal. You shall be responsible for reviewing and becoming </span>
          <span id="_14.1" style={{ fontSize: '13.8px', color: '#000000'}}>
            familiar with any such modifications. Use of the HMP Services by you after any modification to the HMP Terms </span>
          <span id="_14.1" style={{ fontSize: '13.8px', color: '#000000'}}>
            constitutes your acceptance of these HMP Terms as so modified.</span>
        </div>
        <div className="pos" id="_91:2024" style={{top: 2024, left: 91}}>
          <span id="_14.1" style={{fontWeight: 'bold',  fontSize: '13.8px', color: '#000000'}}>
            4. Eligibility</span>
        </div>
        <div className="pos" id="_91:2056" style={{top: 2056, left: 91}}>
          <span id="_14.1" style={{ fontSize: '13.8px', color: '#000000'}}>
            4.1 You hereby represent and warrant that you are fully able and competent to accept these HMP Terms and to </span>
          <span id="_14.1" style={{ fontSize: '13.8px', color: '#000000'}}>
            abide by and comply with these HMP Terms.</span>
        </div>
        <div className="pos" id="_91:2107" style={{top: 2107, left: 91}}>
          <span id="_14.1" style={{ fontSize: '13.8px', color: '#000000'}}>
            4.2 By submitting an HMP Application you are representing and warranting that:</span>
        </div>
        <div className="pos" id="_91:2138" style={{top: 2138, left: 91}}>
          <span id="_14.1" style={{ fontSize: '13.8px', color: '#000000'}}>
            (a) you are a Media representative.</span>
        </div>
        <div className="pos" id="_91:2170" style={{top: 2170, left: 91}}>
          <span id="_14.1" style={{ fontSize: '13.8px', color: '#000000'}}>
            (b) to the extent that you are applying for another individual (one or more) you warrant that:</span>
        </div>
        <div className="pos" id="_241:2201" style={{top: 2201, left: 241}}>
          <span id="_14.1" style={{ fontSize: '13.8px', color: '#000000'}}>
            (i) you have obtained their approval of these HMP Terms.</span>
        </div>
        <div className="pos" id="_241:2232" style={{top: 2232, left: 241}}>
          <span id="_14.7" style={{ fontSize: '14.7px', color: '#000000'}}>
            (ii) you have obtained their consent to provide this confirmation on their behalf on the </span>
          <span id="_14.0" style={{ fontSize: '14.0px', color: '#000000'}}>
            Hayya Media Portal.</span>
        </div>
        <div className="pos" id="_91:2451" style={{top: 2451, left: 91}}>
          <span id="_14.1" style={{ fontSize: '13.8px', color: '#000000'}}>
            (c) where you are not a citizen or resident of the State of Qatar, you will ensure that you have obtained a valid visa </span>
          <span id="_14.1" style={{ fontSize: '13.8px', color: '#000000'}}>
            prior to arriving in Qatar, or you are in Qatar and hold a valid visa.</span>
        </div>
        <div className="pos" id="_91:2502" style={{top: 2502, left: 91}}>
          <span id="_14.1" style={{ fontSize: '13.8px', color: '#000000'}}>
            d) you will comply with the terms of any visa issued to you on arrival in Qatar.</span>
        </div>
        <div className="pos" id="_91:2533" style={{top: 2533, left: 91}}>
          <span id="_14.1" style={{ fontSize: '13.8px', color: '#000000'}}>
            (e) you will abide by all laws of the State of Qatar during your time in Qatar.</span>
        </div>
        <div className="pos" id="_91:2565" style={{top: 2565, left: 91}}>
          <span id="_14.1" style={{ fontSize: '13.8px', color: '#000000'}}>
            (f) you will abide at all times by these HMP Terms, the Hayya Terms, the Accreditation Terms and the Filming Permit </span>
          <span id="_15.0" style={{ fontSize: '15.0px', color: '#000000'}}>
            Terms.</span>
        </div>
        <div className="pos" id="_91:2616" style={{top: 2616, left: 91}}>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            4.3  If  SC  or  any  other  State  of  Qatar  government  entity  determines  that  you  do  not  meet  the  eligibility </span>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            requirements, then you are not authorized to use the Hayya Media Portal Services and SC reserves the right to </span>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            terminate your access to the Hayya Media Portal.</span>
        </div>
        <div className="pos" id="_91:2687" style={{top: 2687, left: 91}}>
          <span id="_13.9" style={{fontWeight: 'bold',  fontSize: '13.9px', color: '#000000'}}>
            5. Conditions of Participation</span>
        </div>
        <div className="pos" id="_91:2719" style={{top: 2719, left: 91}}>
          <span id="_13.9" style={{ fontSize: '13.9px', color: '#000000'}}>
            5.1 To obtain access to the HMP Services you will need to register for an account on the HMP. By making an HMP </span>
          <span id="_13.9" style={{ fontSize: '13.9px', color: '#000000'}}>
            Application, you agree to provide accurate, current, complete and continually maintained and updated information </span>
          <span id="_13.9" style={{ fontSize: '13.9px', color: '#000000'}}>
            about yourself and that of any individuals that you are applying on behalf of.</span>
        </div>
        <div className="pos" id="_91:2790" style={{top: 2790, left: 91}}>
          <span id="_13.9" style={{ fontSize: '13.9px', color: '#000000'}}>
            5.2 If you provide any information that is inaccurate, not current or incomplete, or SC has reasonable grounds to </span>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            suspect  that  such  information  is  inaccurate,  not  current  or  incomplete,  or  if  you  are  not  eligible  to  apply  for </span>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            registration with the Hayya Media Portal, SC may deny your Application, cancel your access to the Hayya Media </span>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            Portal at its sole discretion. </span>
        </div>
        <div className="pos" id="_91:2882" style={{top: 2882, left: 91}}>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            5.3 You agree that the sole and specific purpose of applying on the HMP is to access the HMP Services pre- and </span>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            during the Event applied for. SC shall be entitled to suspend, limit or terminate your access to the HMP if we </span>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            determine, in our sole discretion, that you are misusing the HMP Services. In such circumstances, we may also </span>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            report such activity to relevant authorities.</span>
        </div>
        <div className="pos" id="_91:2973" style={{top: 2973, left: 91}}>
          <span id="_14.3" style={{fontWeight: 'bold',  fontSize: '14.3px', color: '#000000'}}>
            6. Application Data</span>
        </div>
        <div className="pos" id="_91:3005" style={{top: 3005, left: 91}}>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            6.1 To register with the HMP, you will be required to submit such information as detailed on the portal.</span>
        </div>
        <div className="pos" id="_91:3036" style={{top: 3036, left: 91}}>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            6.2 Your Application Data will be processed as per the terms of the HMP Privacy Policy and the consents, which </span>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            you will be required to consider and if you so choose, to grant at various intersections of your HMP Application. </span>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            These consents are required in order for your HMP Application to be submitted and considered.</span>
        </div>
        <div className="pos" id="_91:3107" style={{top: 3107, left: 91}}>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            6.3 You cannot register with the HMP without providing the mandatory information set out on the portal.</span>
        </div>
        <div className="pos" id="_91:3139" style={{top: 3139, left: 91}}>
          <span id="_13.7" style={{fontWeight: 'bold',  fontSize: '13.7px', color: '#000000'}}>
            7. Application Process</span>
        </div>
        <div className="pos" id="_91:3170" style={{top: 3170, left: 91}}>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            7.1 Once you have submitted your HMP Application on the Hayya Media Portal you will receive confirmation of </span>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            your Application status via email, and you will receive a response on whether your Application is completed.</span>
        </div>
        <div className="pos" id="_91:3221" style={{top: 3221, left: 91}}>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            7.2 If your Application is successful, you will receive a notification indicating that your Application is approved.</span>
        </div>
        <div className="pos" id="_91:3253" style={{top: 3253, left: 91}}>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            7.3 SC reserves the right to request additional information and/or data where the information and data provided </span>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            is deemed insufficient to approve your Application.</span>
        </div>
        <div className="pos" id="_91:3304" style={{top: 3304, left: 91}}>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            7.4 You may supplement or amend your Application via the Hayya Media Portal. However, you cannot amend an </span>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            Application which is in progress.</span>
        </div>
        <div className="pos" id="_91:3355" style={{top: 3355, left: 91}}>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            7.5 Whilst the Hayya Terms and/or Accreditation Terms may refer to an application and approval process specific </span>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            to Hayya and/or accreditation, you shall submit your Application and receive an approval of the same in accordance </span>
          <span id="_14.3" style={{ fontSize: '14.3px', color: '#000000'}}>
            with these HMP Terms.</span>
        </div>
        <div className="pos" id="_91:3621" style={{top: 3621, left: 91}}>
          <span id="_13.9" style={{fontWeight: 'bold',  fontSize: '13.9px', color: '#000000'}}>
            8. Termination or Cancellation of Hayya Media Portal Service</span>
        </div>
        <div className="pos" id="_91:3652" style={{top: 3652, left: 91}}>
          <span id="_13.9" style={{ fontSize: '13.9px', color: '#000000'}}>
            8.1 SC reserves the right to terminate or suspend the Hayya Media Portal Services at any time if you fail to comply </span>
          <span id="_13.9" style={{ fontSize: '13.9px', color: '#000000'}}>
            with these Terms, or for any other reason as set out in these Terms.</span>
        </div>
        <div className="pos" id="_91:3703" style={{top: 3703, left: 91}}>
          <span id="_13.9" style={{fontWeight: 'bold',  fontSize: '13.9px', color: '#000000'}}>
            9. Waiver and Release of Liability</span>
            </div>
        <div className="pos" id="_91:3703" style={{top: 3703, left: 91}}>
          <span id="_14.4" style={{ fontSize: '14.4px', color: '#000000'}}>
            To the maximum extent permitted under the applicable law, you fully, irrevocably and unconditionally waive any </span>
          <span id="_14.4" style={{ fontSize: '14.4px', color: '#000000'}}>
            and all claims against SC and all of its respective affiliated entities, and their respective officers, directors, agents, </span>
          <span id="_14.4" style={{ fontSize: '14.4px', color: '#000000'}}>
            representatives, employees, elected and appointed officials of each of the foregoing entities (collectively, the </span>
          <span id="_14.4" style={{ fontSize: '14.4px', color: '#000000'}}>
            “Indemnified Entities”) and agree that the Indemnified Entities will have no liability or responsibility for any claim </span>
          <span id="_14.4" style={{ fontSize: '14.4px', color: '#000000'}}>
            arising in connection with your Application, the Hayya Media Portal Services and/or the Hayya Media Portal Mobile </span>
          <span id="_14.4" style={{ fontSize: '14.4px', color: '#000000'}}>
            App. The Indemnified Entities do not operate and have no control over your Application, the Hayya Media Portal </span>
          <span id="_14.4" style={{ fontSize: '14.4px', color: '#000000'}}>
            Services or the Mobile App. If you fail to obtain registration with the Hayya Media Portal or if your Application is </span>
          <span id="_14.4" style={{ fontSize: '14.4px', color: '#000000'}}>
            cancelled or terminated for any reason, you will not be entitled to any refunds from any of the Indemnified Entities.</span>
        </div>
        <div className="pos" id="_91:3907" style={{top: 3907, left: 91}}>
          <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000000'}}>
            10. Miscellaneous</span>
        </div>
        <div className="pos" id="_91:3938" style={{top: 3938, left: 91}}>
          <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000000'}}>
            10.1 Governing Law and Disputes:<span style={{fontWeight: 'normal'}}> These Terms and any disputes or claims arising out of or in connection with </span></span>
          <span id="_14.0" style={{ fontSize: '14.0px', color: '#000000'}}>
            them  or  its  subject  matter  or  formation  (including  non-contractual  disputes  or  claims)  are  governed  by  and </span>
          <span id="_14.0" style={{ fontSize: '14.0px', color: '#000000'}}>
            construed in accordance with the laws of the State of Qatar. Unless settled or otherwise agreed by both Parties, </span>
          <span id="_14.4" style={{ fontSize: '14.4px', color: '#000000'}}>
            any dispute or difference shall be finally determined under the exclusive jurisdiction of the courts of the State of </span>
          <span id="_15.0" style={{ fontSize: '15.0px', color: '#000000'}}>
            Qatar.</span>
        </div>
        <div className="pos" id="_91:4050" style={{top: 4050, left: 91}}>
          <span id="_13.9" style={{fontWeight: 'bold',  fontSize: '13.9px', color: '#000000'}}>
            10.2 Assignment:<span style={{fontWeight: 'normal'}}> SC shall be free to assign or transfer any of its rights or obligations under the Services at any time </span></span>
          <span id="_13.9" style={{ fontSize: '13.9px', color: '#000000'}}>
            without your consent. You may not assign or transfer any of your rights or obligations.</span>
        </div>
        <div className="pos" id="_91:4101" style={{top: 4101, left: 91}}>
          <span id="_13.9" style={{fontWeight: 'bold',  fontSize: '13.9px', color: '#000000'}}>
            10.3 Severance:<span style={{fontWeight: 'normal'}}> If any provision (or part of a provision) of these Terms are found by any court or administrative </span></span>
          <span id="_13.9" style={{ fontSize: '13.9px', color: '#000000'}}>
            body of competent jurisdiction to be invalid, unenforceable or illegal, the other provisions shall remain in force. If </span>
          <span id="_13.9" style={{ fontSize: '13.9px', color: '#000000'}}>
            any invalid, unenforceable or illegal provision would be valid, enforceable or legal if some part of it were deleted, </span>
          <span id="_13.9" style={{ fontSize: '13.9px', color: '#000000'}}>
            the provision shall apply with whatever modification is necessary to give effect to our commercial intention.</span>
        </div>
        <div className="pos" id="_91:4193" style={{top: 4193, left: 91}}>
          <span id="_13.9" style={{fontWeight: 'bold',  fontSize: '13.9px', color: '#000000'}}>
            11. Contacting Us</span>
        </div>
        <div className="pos" id="_91:4224" style={{top: 4224, left: 91}}>
          <span id="_13.9" style={{ fontSize: '13.9px', color: '#000000'}}>
            If you have any questions, please email media@hayya.qa.</span>
        </div>
        <div className="pos text-center my-3" id="_408:4791" style={{top: 4791, left: 408}}>
          <span id="_18.5" style={{fontWeight: 'bold',  fontSize: '18.5px', color: '#000000'}}>
            Appendix 1</span>
        </div>
        <div className="pos" id="_403:4822" style={{top: 4822, left: 403}}>
          <span id="_18.5" style={{fontWeight: 'bold',  fontSize: '18.5px', color: '#000000'}}>
            Hayya Terms </span>
        </div>
        <div className="pos mb-3" id="_371:4853" style={{top: 4853, left: 371}}>
          <span id="_18.5" style={{fontWeight: 'bold',  fontSize: '18.5px', color: '#000000'}}>
            <u>T</u><u>e</u><u>r</u><u>m</u><u>s</u><u> </u><u>o</u><u>f</u><u> </u><u>I</u><u>s</u><u>s</u><u>u</u><u>e</u><u> </u><u>a</u><u>n</u><u>d</u><u> </u><u>U</u><u>s</u><u>e</u></span>
        </div>
        <div className="pos" id="_91:4884" style={{top: 4884, left: 91}}>
          <span id="_18.5" style={{fontWeight: 'bold',  fontSize: '18.5px', color: '#000'}}>
            1.             Definitions</span>
        </div>
        <div className="pos" id="_91:4922" style={{top: 4922, left: 91}}>
          <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
            The following definitions are used in these Terms:</span>
        </div>
        <div className="pos" id="_91:4960" style={{top: 4960, left: 91}}>
          <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
            SC<span style={{fontWeight: 'normal'}}> ,</span> we<span style={{fontWeight: 'normal'}}> or </span> us<span style={{fontWeight: 'normal'}}> means the Supreme Committee for Delivery &amp; Legacy, an entity established under the laws of the </span></span>
        </div>
        <div className="pos" id="_91:4979" style={{top: 4979, left: 91}}>
          <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
            State of Qatar pursuant to Emiri Decree No. 69 of 2024 and its successors and assigns.</span>
        </div>
        <div className="pos" id="_91:5017" style={{top: 5017, left: 91}}>
          <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
            You<span style={{fontWeight: 'normal'}}> , the </span> Applicant<span style={{fontWeight: 'normal'}}> , means any person who makes an Application.</span></span>
        </div>
        <div className="pos" id="_91:5055" style={{top: 5055, left: 91}}>
          <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
            Application <span style={{fontWeight: 'normal'}}> means an application for a Hayya ID in accordance with these Terms.</span></span>
        </div>
        <div className="pos" id="_91:5093" style={{top: 5093, left: 91}}>
          <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
            Application Data <span style={{fontWeight: 'normal'}}> means all data you submit as part of your Application or any Application for another person that </span></span>
          <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
            you are permitted to make.</span>
        </div>
        <div className="pos" id="_91:5150" style={{top: 5150, left: 91}}>
          <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
            Events <span style={{fontWeight: 'normal'}}> means events SC is involved in organising or promoting.</span></span>
        </div>
        <div className="pos" id="_91:5188" style={{top: 5188, left: 91}}>
          <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
            FAQs <span style={{fontWeight: 'normal'}}> means the frequently asked questions document which can be found at <u>F</u><u>A</u><u>Q</u><u> </u><u>–</u><u> </u><u>H</u><u>a</u><u>y</u><u>y</u><u>a</u><u> </u><u>–</u><u> </u><u>P</u><u>o</u><u>r</u><u>t</u><u>a</u><u>l</u> .</span></span>
        </div>
        <div className="pos" id="_91:5226" style={{top: 5226, left: 91}}>
          <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
            Hayya ID <span style={{fontWeight: 'normal'}}> means the digital identity issued to you upon approval of your Application.</span></span>
        </div>
        <div className="pos" id="_91:5264" style={{top: 5264, left: 91}}>
          <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
            Hayya Entry Types <span style={{fontWeight: 'normal'}}> means the various Hayya entry types that can be applied for by way of an Application, as set </span></span>
          <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
            out in the FAQs.</span>
        </div>
        <div className="pos" id="_91:5321" style={{top: 5321, left: 91}}>
          <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
            Hayya Mobile App <span style={{fontWeight: 'normal'}}> means the mobile app launched by SC to provide the Hayya ID, which is available at the App </span></span>
          <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
            Store with the name ‘Hayya to Qatar’.</span>
        </div>
        <div className="pos" id="_91:5378" style={{top: 5378, left: 91}}>
          <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
            Hayya Portal <span style={{fontWeight: 'normal'}}> means the URL where Applicants can make an Application and which is hosted at  Hayya Portal.</span></span>
        </div>
        <div className="pos" id="_91:5416" style={{top: 5416, left: 91}}>
          <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
            Hayya Service Centre <span style={{fontWeight: 'normal'}}> means the service centres as advised by SC when an Applicant is notified of its successful </span></span>
          <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
            Application.</span>
        </div>
        <div className="pos" id="_91:5473" style={{top: 5473, left: 91}}>
          <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
            Hayya Services <span style={{fontWeight: 'normal'}}> means the services to be offered by the Hayya ID, whether by SC or a third party.</span></span>
        </div>
        <div className="pos" id="_91:5511" style={{top: 5511, left: 91}}>
          <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
            Indemnified Entities <span style={{fontWeight: 'normal'}}> has the definition set out in Clause 11 of these Terms.</span></span>
        </div>
        <div className="pos" id="_91:5549" style={{top: 5549, left: 91}}>
          <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
            Platform <span style={{fontWeight: 'normal'}}> means the Hayya Mobile App, the Hayya Portal, or other platforms which SC may offer from time to time; </span></span>
          <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
            and Platforms means two or more of these platforms (as the context requires).</span>
        </div>
        <div className="pos" id="_91:5606" style={{top: 5606, left: 91}}>
          <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
            Privacy Policy <span style={{fontWeight: 'normal'}}> means the SC’s privacy policy which governs the collection of data on the Hayya Portal and Hayya </span></span>
          <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
            Mobile App, which can be found at <span style={{fontStyle: 'italic'}}> [ <u>h</u><u>t</u><u>t</u><u>p</u><u>s</u><u>:</u><u>/</u><u>/</u><u>h</u><u>a</u><u>y</u><u>y</u><u>a</u><u>.</u><u>q</u><u>a</u><u>/</u><u>e</u><u>n</u><u>/</u><u>p</u><u>r</u><u>i</u><u>v</u><u>a</u><u>c</u><u>y</u><u>-</u><u>p</u><u>o</u><u>l</u><u>i</u><u>c</u><u>y</u> </span> ].</span>
        </div>
        <div className="pos" id="_91:5662" style={{top: 5662, left: 91}}>
          <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
            QID <span style={{fontWeight: 'normal'}}> means a Qatar Identity Document.</span></span>
        </div>
        <div className="pos" id="_91:5700" style={{top: 5700, left: 91}}>
          <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
            Terms<span style={{fontWeight: 'normal'}}> means these terms of issue and use of a Hayya ID.</span></span>
        </div>
        <div className="pos" id="_91:5739" style={{top: 5739, left: 91}}>
          <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
            Terms of Use <span style={{fontWeight: 'normal'}}> means the terms of use for the qatar2022. website, which can be found at 
              </span></span>
        
          <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
            <a href="https://hayya.qa/en/web-hayya-terms-of-use"> https://hayya.qa/en/web-hayya-terms-of-use</a> , and the terms of use of the Hayya Mobile App, which can be found on the Hayya Mobile App.</span>
          </div>
          {/* <div className="pos" id="_0:0" style={{top: 5850}}> */}
            {/* <img name="_1170:828" src="page_006.jpg" height={1170} width={828} border={0} useMap="#Map" /></div> */}
        
          <div className="pos" id="_91:5961" style={{top: 5961, left: 91}}>
            <span id="_18.5" style={{fontWeight: 'bold',  fontSize: '18.5px', color: '#000'}}>
              2.             Acceptance of Terms</span>
          </div>
          <div className="pos" id="_91:5999" style={{top: 5999, left: 91}}>
            <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000'}}>
              2.1 <span style={{fontWeight: 'normal'}}> These Terms set out the process by which an Application may be made, the basis upon which SC will issue </span></span>
          
            <span id="_14.0" style={{ fontSize: '14.0px', color: '#000'}}>
              a Hayya ID, and the terms for use of the Hayya ID by a successful Applicant. The application process is set out in </span>
            <span id="_14.6" style={{ fontSize: '14.6px', color: '#000'}}>
              further detail in the FAQs, which users should refer to prior to making an Application. SC may also designate </span>

            <span id="_14.6" style={{ fontSize: '14.6px', color: '#000'}}>
              alternative routes for submitting an Application. </span>
          </div>
          <div className="pos" id="_91:6093" style={{top: 6093, left: 91}}>
            <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000'}}>
              2.2          <span style={{fontWeight: 'normal'}}> Before applying for a Hayya ID you should ensure that you have read and understood these Terms.</span></span>
          </div>
          <div className="pos" id="_91:6131" style={{top: 6131, left: 91}}>
            <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000'}}>
              2.3          <span style={{fontWeight: 'normal'}}> By using or otherwise accessing the Hayya Services, attending Events, or clicking to accept or agree to </span></span>
          
            <span id="_14.0" style={{ fontSize: '14.0px', color: '#000'}}>
              these Terms where that option is made available, you:</span>
          </div>
          <div className="pos" id="_91:6188" style={{top: 6188, left: 91}}>
            <span id="_14.0" style={{ fontSize: '14.0px', color: '#000'}}>
              (a)  accept and agree to these Terms and any additional policies which relate to Events and the Hayya Services; </span>
          </div>
          <div className="pos" id="_91:6206" style={{top: 6206, left: 91}}>
            <span id="_15.0" style={{ fontSize: '15.0px', color: '#000'}}>
              and</span>
          </div>
          <div className="pos" id="_91:6245" style={{top: 6245, left: 91}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
              (b) agree to any additional terms, rules and conditions issued by SC from time to time in relation to the use </span>
          
            <span id="_13.7" style={{ fontSize: '13.7px', color: '#000'}}>
              of a Hayya ID.</span>
          </div>
          <div className="pos" id="_91:6301" style={{top: 6301, left: 91}}>
            <span id="_13.7" style={{fontWeight: 'bold',  fontSize: '13.7px', color: '#000'}}>
              3.             Modification of Terms</span>
          </div>
          <div className="pos" id="_91:6339" style={{top: 6339, left: 91}}>
            <span id="_13.7" style={{ fontSize: '13.7px', color: '#000'}}>
              SC reserves the right, at its sole discretion, to modify or replace these Terms at any time. Updated versions of these </span>
          
            <span id="_13.7" style={{ fontSize: '13.7px', color: '#000'}}>
              Terms will be posted on the Hayya Portal and/or the Hayya Mobile App. You shall be responsible for reviewing and </span>
          
            <span id="_14.3" style={{ fontSize: '14.3px', color: '#000'}}>
              becoming familiar with any such modifications. Use of the Hayya Services and attendance to any Events by you </span>
            
            <span id="_14.3" style={{ fontSize: '14.3px', color: '#000'}}>
              after any modification to the Terms constitutes your acceptance of these Terms as so modified and notified to you.</span>
          </div>
          <div className="pos" id="_91:6433" style={{top: 6433, left: 91}}>
            <span id="_13.7" style={{fontWeight: 'bold',  fontSize: '13.7px', color: '#000'}}>
              4.             Purpose of Hayya ID</span>
          </div>
          <div className="pos" id="_91:6471" style={{top: 6471, left: 91}}>
            <span id="_13.7" style={{fontWeight: 'bold',  fontSize: '13.7px', color: '#000'}}>
              4.1          <span style={{fontWeight: 'normal'}}> A Hayya ID:</span></span>
          </div>
          <div className="pos" id="_91:6510" style={{top: 6510, left: 91}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
              (a)           will provide a means of entry into the State of Qatar for international visitors; and</span>
          </div>
          <div className="pos" id="_91:6548" style={{top: 6548, left: 91}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
              (b)           may provide a means of identification for visitors with a number of services aimed at enhancing their </span>
           
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
              experience while in Qatar.</span>
          </div>
          <div className="pos" id="_91:6604" style={{top: 6604, left: 91}}>
            <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
              4.2          <span style={{fontWeight: 'normal'}}> A Hayya ID may also provide you with access to the Hayya Services and allow you to attend Events.</span></span>
          </div>
          <div className="pos" id="_91:6642" style={{top: 6642, left: 91}}>
            <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
              4.3          <span style={{fontWeight: 'normal'}}> Some of the Hayya Services and Events are provided by third parties and provision of those services may </span></span>
           
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
              be subject to terms and conditions of the third party service provider or other specific terms imposed by SC. Such </span>
           
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
              additional terms will be notified to you prior to such service being made available to you. You will ensure that you </span>
           
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
              are aware of the terms and conditions that apply to provision of the third party services or other specific terms </span>
           
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
              imposed by SC and will not use such services unless you accept those terms.</span>
          </div>
          <div className="pos" id="_91:6755" style={{top: 6755, left: 91}}>
            <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
              4.4          <span style={{fontWeight: 'normal'}}> SC does not accept any responsibility for services or Events provided by any third party.</span></span>
          </div>
          <div className="pos" id="_91:6793" style={{top: 6793, left: 91}}>
            <span id="_13.8" style={{fontWeight: 'bold',  fontSize: '13.8px', color: '#000'}}>
              5.             Eligibility</span>
          </div>
          <div className="pos" id="_91:6831" style={{top: 6831, left: 91}}>
            <span id="_14.4" style={{fontWeight: 'bold',  fontSize: '14.4px', color: '#000'}}>
              5.1          <span style={{fontWeight: 'normal'}}> You hereby represent and warrant that you are fully able and competent to accept these Terms and to </span></span>
           
            <span id="_14.4" style={{ fontSize: '14.4px', color: '#000'}}>
              abide by and comply with these Terms.</span>
          </div>
          <div className="pos" id="_91:6888" style={{top: 6888, left: 91}}>
            <span id="_14.4" style={{fontWeight: 'bold',  fontSize: '14.4px', color: '#000'}}>
              5.2          <span style={{fontWeight: 'normal'}}> By submitting an Application you are representing and warranting that:</span></span>
          </div>
          {/* <div className="pos" id="_0:0" style={{top: 7020}}> */}
            {/* <img name="_1170:828" src="page_007.jpg" height={1170} width={828} border={0} useMap="#Map" /></div> */}
          <div className="pos" id="_28:7036" style={{top: 7036, left: 28}}>
            
          </div>
          <div className="pos" id="_91:7131" style={{top: 7131, left: 91}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
              (a)           you are of 18 years of age or older or you are the parent or guardian of the Applicant, or where you are </span>
           
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
              applying on behalf a GCC Companion, you are the sponsor of such companion ;</span>
          </div>
          <div className="pos" id="_91:7188" style={{top: 7188, left: 91}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
              (b)           to the extent that you are applying for another individual (one or more) you warrant that:</span>
          </div>
          <div className="pos" id="_91:7226" style={{top: 7226, left: 91}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
              (i)            you have obtained their approval of these Terms;</span>
          </div>
          <div className="pos" id="_91:7264" style={{top: 7264, left: 91}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
              (ii)           you have obtained their consent to provide this confirmation on their behalf on the Hayya Portal and/or </span>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
              Hayya Mobile App; and</span>
          </div>
          <div className="pos" id="_91:7320" style={{top: 7320, left: 91}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
              (iii)          such other individuals are either over 18 or if they are under 18 that the consent from their parent or </span>
           
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
              guardian has been obtained;</span>
          </div>
          <div className="pos" id="_91:7377" style={{top: 7377, left: 91}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
              (c)           you will abide by all laws of the State of Qatar during your time in Qatar;</span>
          </div>
          <div className="pos" id="_91:7415" style={{top: 7415, left: 91}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
              (d)           you will abide at all times by these Terms..</span>
          </div>
          <div className="pos" id="_91:7453" style={{top: 7453, left: 91}}>
            <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
              5.3          <span style={{fontWeight: 'normal'}}> If </span><span style={{fontWeight: 'normal'}}> SC </span><span style={{fontWeight: 'normal'}}> or </span><span style={{fontWeight: 'normal'}}> any </span><span style={{fontWeight: 'normal'}}> other </span><span style={{fontWeight: 'normal'}}> State </span><span style={{fontWeight: 'normal'}}> of </span><span style={{fontWeight: 'normal'}}> Qatar </span><span style={{fontWeight: 'normal'}}> government </span><span style={{fontWeight: 'normal'}}> entity </span><span style={{fontWeight: 'normal'}}> determines </span><span style={{fontWeight: 'normal'}}> that </span><span style={{fontWeight: 'normal'}}> you </span><span style={{fontWeight: 'normal'}}> do </span><span style={{fontWeight: 'normal'}}> not </span><span style={{fontWeight: 'normal'}}> meet </span><span style={{fontWeight: 'normal'}}> the </span><span style={{fontWeight: 'normal'}}> eligibility </span></span>
           
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
              requirements for a Hayya ID, then you are not authorized to use the Hayya Services and attend any Events and SC </span>
           
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000'}}>
              reserves the right to terminate your access to the Hayya Mobile App and the Hayya Portal.</span>
          </div>
          <div className="pos" id="_91:7529" style={{top: 7529, left: 91}}>
            <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
              5.4          <span style={{fontWeight: 'normal'}}> The eligibility requirements for the Hayya Entry Types are set out in the FAQs</span></span>
          </div>
          <div className="pos" id="_91:7567" style={{top: 7567, left: 91}}>
            <span id="_13.8" style={{fontWeight: 'bold',  fontSize: '13.8px', color: '#000'}}>
              6.             Conditions of Participation</span>
          </div>
          <div className="pos" id="_91:7605" style={{top: 7605, left: 91}}>
            <span id="_13.8" style={{fontWeight: 'bold',  fontSize: '13.8px', color: '#000'}}>
              6.1          <span style={{fontWeight: 'normal'}}> To obtain a Hayya ID you will need to register for a Hayya account in order to apply, or log in to the Hayya </span></span>
           
            <span id="_14.5" style={{ fontSize: '14.5px', color: '#000'}}>
              Portal or Hayya Mobile App, or follow such other route as we may designate for submitting an Application. By </span>
           
            <span id="_14.5" style={{ fontSize: '14.5px', color: '#000'}}>
              making an Application, you agree to provide accurate, current and complete information about yourself and that </span>
           
            <span id="_14.5" style={{ fontSize: '14.5px', color: '#000'}}>
              of any individuals that you are applying on behalf of, and maintain and promptly update the Application Data to </span>
           
            <span id="_14.5" style={{ fontSize: '14.5px', color: '#000'}}>
              keep it accurate, current and complete.</span>
          </div>
          <div className="pos" id="_91:7718" style={{top: 7718, left: 91}}>
            <span id="_14.1" style={{fontWeight: 'bold',  fontSize: '13.8px', color: '#000'}}>
              6.2          <span style={{fontWeight: 'normal'}}> If you provide any information that is inaccurate, not current or incomplete, or SC has reasonable grounds </span></span>
            <span id="_14.1" style={{ fontSize: '13.8px', color: '#000'}}>
              to suspect that such information is inaccurate, not current or incomplete, SC may deny your Application, cancel </span>
           
            <span id="_14.1" style={{ fontSize: '13.8px', color: '#000'}}>
              your access to the Hayya Portal and Hayya Mobile App or terminate any Hayya ID that may have been issued, at its </span>
           
            <span id="_14.1" style={{ fontSize: '13.8px', color: '#000'}}>
              sole discretion. Please refer to the Terms of Use for more information on how the Hayya Portal and Hayya Mobile </span>
            <span id="_14.1" style={{ fontSize: '13.8px', color: '#000'}}>
              App should be used.</span>
          </div>
          <div className="pos" id="_91:7830" style={{top: 7830, left: 91}}>
            <span id="_14.1" style={{fontWeight: 'bold',  fontSize: '13.8px', color: '#000'}}>
              6.3          <span style={{fontWeight: 'normal'}}> You agree that the purpose of applying for the Hayya ID are:</span></span>
          </div>
          <div className="pos" id="_91:7868" style={{top: 7868, left: 91}}>
            <span id="_14.1" style={{ fontSize: '13.8px', color: '#000'}}>
              (a)           for international visitors, to enter the State of Qatar; and</span>
          </div>
          <div className="pos" id="_91:7907" style={{top: 7907, left: 91}}>
            <span id="_14.1" style={{ fontSize: '13.8px', color: '#000'}}>
              (b)           to access Hayya Services where available, [and attend Events during your stay.</span>
          </div>
          <div className="pos" id="_91:7945" style={{top: 7945, left: 91}}>
            <span id="_14.1" style={{fontWeight: 'bold',  fontSize: '13.8px', color: '#000'}}>
              6.4          <span style={{fontWeight: 'normal'}}> SC shall be entitled to suspend, limit or terminate your Hayya ID if we determine, in our sole discretion, </span></span>
          
            <span id="_14.1" style={{ fontSize: '13.8px', color: '#000'}}>
              that you are misusing the Hayya ID or the Hayya Services. In such circumstances, we may also report such activity </span>
           
            <span id="_14.5" style={{ fontSize: '14.5px', color: '#000'}}>
              to relevant authorities.</span>
          </div>
          <div className="pos" id="_91:8020" style={{top: 8020, left: 91}}>
            <span id="_13.8" style={{fontWeight: 'bold',  fontSize: '13.8px', color: '#000'}}>
              7.             Hayya ID Application Data</span>
          </div>
          <div className="pos" id="_91:8058" style={{top: 8058, left: 91}}>
            <span id="_13.8" style={{fontWeight: 'bold',  fontSize: '13.8px', color: '#000'}}>
              7.1          <span style={{fontWeight: 'normal'}}> To apply for a Hayya ID you will be required to submit such information as detailed on the Hayya Portal or </span></span>
           
            <span id="_13.8" style={{ fontSize: '13.8px', color: '#000'}}>
              Hayya Mobile App.</span>
          </div>
          {/* <div className="pos" id="_0:0" style={{top: 8190}}> */}
            {/* <img name="_1170:828" src="page_008.jpg" height={1170} width={828} border={0} useMap="#Map" /></div> */}
        
          <div className="pos" id="_91:8301" style={{top: 8301, left: 91}}>
            <span id="_14.3" style={{fontWeight: 'bold',  fontSize: '14.3px', color: '#000'}}>
              7.2          <span style={{fontWeight: 'normal'}}> Your Application Data will be processed as per the terms of the Privacy Policy and the consents where </span></span>
           
            <span id="_14.3" style={{ fontSize: '14.3px', color: '#000'}}>
              applicable, which you will be required to consider and if you so choose, to grant at various intersections of your </span>
           
            <span id="_14.3" style={{ fontSize: '14.3px', color: '#000'}}>
              Application. These consents are required in order for your Application to be submitted and considered.</span>
          </div>
          <div className="pos" id="_91:8376" style={{top: 8376, left: 91}}>
            <span id="_14.3" style={{fontWeight: 'bold',  fontSize: '14.3px', color: '#000'}}>
              7.3          <span style={{fontWeight: 'normal'}}> You cannot apply for a Hayya ID without providing the mandatory information set out on the Hayya Portal </span></span>
           
            <span id="_14.3" style={{ fontSize: '14.3px', color: '#000'}}>
              or Hayya Mobile App, or as set out in such other route designated by SC.</span>
          </div>
          <div className="pos" id="_91:8433" style={{top: 8433, left: 91}}>
            <span id="_13.6" style={{fontWeight: 'bold',   color: '#000'}}>
              8.             Application Process</span>
          </div>
          <div className="pos" id="_91:8471" style={{top: 8471, left: 91}}>
            <span id="_14.3" style={{fontWeight: 'bold',  fontSize: '14.3px', color: '#000'}}>
              8.1          <span style={{fontWeight: 'normal'}}> Once you have submitted your Application you will receive confirmation of your Application number via </span></span>
          
            <span id="_14.3" style={{ fontSize: '14.3px', color: '#000'}}>
              email, and you will receive a response on whether your Application is successful.</span>
          </div>
          <div className="pos" id="_91:8528" style={{top: 8528, left: 91}}>
            <span id="_14.3" style={{fontWeight: 'bold',  fontSize: '14.3px', color: '#000'}}>
              8.2          <span style={{fontWeight: 'normal'}}> You will be able to track the progress of your Application on the Hayya Portal and Hayya Mobile App, or </span></span>
           
            <span id="_14.3" style={{ fontSize: '14.3px', color: '#000'}}>
              through such other route we designate for your Application.</span>
          </div>
          <div className="pos" id="_91:8584" style={{top: 8584, left: 91}}>
            <span id="_14.3" style={{fontWeight: 'bold',  fontSize: '14.3px', color: '#000'}}>
              8.3          <span style={{fontWeight: 'normal'}}> If your Application is successful, you will receive a notification indicating that your Application has been </span></span>
           
            <span id="_13.9" style={{ fontSize: '13.9px', color: '#000'}}>
              successful.</span>
          </div>
          <div className="pos" id="_91:8641" style={{top: 8641, left: 91}}>
            <span id="_14.3" style={{fontWeight: 'bold',  fontSize: '14.3px', color: '#000'}}>
              8.4          <span style={{fontWeight: 'normal'}}> If </span><span style={{fontWeight: 'normal'}}> your </span><span style={{fontWeight: 'normal'}}> Application </span><span style={{fontWeight: 'normal'}}> is </span><span style={{fontWeight: 'normal'}}> rejected, </span><span style={{fontWeight: 'normal'}}> you </span><span style={{fontWeight: 'normal'}}> will </span><span style={{fontWeight: 'normal'}}> be </span><span style={{fontWeight: 'normal'}}> able </span><span style={{fontWeight: 'normal'}}> to </span><span style={{fontWeight: 'normal'}}> make </span><span style={{fontWeight: 'normal'}}> two </span><span style={{fontWeight: 'normal'}}> further </span><span style={{fontWeight: 'normal'}}> applications </span><span style={{fontWeight: 'normal'}}> by </span><span style={{fontWeight: 'normal'}}> providing </span><span style={{fontWeight: 'normal'}}> the </span></span>
           
            <span id="_14.3" style={{ fontSize: '14.3px', color: '#000'}}>
              Application  Data  and  any  other  additional  information  communicated  to  you.   If  you  have  inserted  incorrect </span>
           
            <span id="_14.3" style={{ fontSize: '14.3px', color: '#000'}}>
              Application Data you will need to wait until you receive a response on your initial Application before you can submit </span>
           
            <span id="_14.3" style={{ fontSize: '14.3px', color: '#000'}}>
              any further Application with correct Application Data.</span>
          </div>
          <div className="pos" id="_91:8735" style={{top: 8735, left: 91}}>
            <span id="_14.3" style={{fontWeight: 'bold',  fontSize: '14.3px', color: '#000'}}>
              8.5          <span style={{fontWeight: 'normal'}}> You may supplement or amend your Application via the Hayya Portal or Hayya Mobile App. However, you </span></span>
            <span id="_14.3" style={{ fontSize: '14.3px', color: '#000'}}>
              cannot amend an Application which is in progress.</span>
          </div>
          <div className="pos" id="_91:8792" style={{top: 8792, left: 91}}>
            <span id="_13.4" style={{fontWeight: 'bold',  fontSize: '13.4px', color: '#000'}}>
              9.             Charges</span>
          </div>
          <div className="pos" id="_91:8830" style={{top: 8830, left: 91}}>
            <span id="_13.9" style={{fontWeight: 'bold',  fontSize: '13.9px', color: '#000'}}>
              9.1          <span style={{fontWeight: 'normal'}}> Please refer to the FAQs for details of any charges associated with an Application or issue of a Hayya ID.</span></span>
          </div>
          <div className="pos" id="_91:8868" style={{top: 8868, left: 91}}>
            <span id="_13.9" style={{fontWeight: 'bold',  fontSize: '13.9px', color: '#000'}}>
              9.2          <span style={{fontWeight: 'normal'}}> Any payment made as anticipated by Clause 9.1 shall not be refundable in any circumstances.</span></span>
          </div>
          <div className="pos" id="_91:8906" style={{top: 8906, left: 91}}>
            <span id="_13.9" style={{fontWeight: 'bold',  fontSize: '13.9px', color: '#000'}}>
              10.          Termination or Cancellation of Hayya ID/Service</span>
          </div>
          <div className="pos" id="_91:8944" style={{top: 8944, left: 91}}>
            <span id="_13.9" style={{fontWeight: 'bold',  fontSize: '13.9px', color: '#000'}}>
              10.1        <span style={{fontWeight: 'normal'}}> SC reserves the right to terminate or suspend the Hayya ID and/or Hayya Services and refuse entry to </span></span>
           
            <span id="_13.9" style={{ fontSize: '13.9px', color: '#000'}}>
              Events at any time if you fail to comply with these Terms, or for any other reason as set out in these Terms.</span>
          </div>
          <div className="pos" id="_91:9001" style={{top: 9001, left: 91}}>
            <span id="_13.9" style={{fontWeight: 'bold',  fontSize: '13.9px', color: '#000'}}>
              11.          Conduct</span>
          </div>
          <div className="pos" id="_91:9039" style={{top: 9039, left: 91}}>
            <span id="_13.9" style={{fontWeight: 'bold',  fontSize: '13.9px', color: '#000'}}>
              11.1        <span style={{fontWeight: 'normal'}}> You will not give, loan, sell or transfer your Hayya ID to any person or organization who is not authorized </span></span>
           
            <span id="_13.9" style={{ fontSize: '13.9px', color: '#000'}}>
              by SC in writing to receive it, and you will not sell or profit from any Hayya With Me codes you may receive from </span>
            
            <span id="_15.0" style={{ fontSize: '15.0px', color: '#000'}}>
              SC.</span>
          </div>
          <div className="pos" id="_91:9115" style={{top: 9115, left: 91}}>
            <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
              11.2        <span style={{fontWeight: 'normal'}}> You agree to comply with any requirements of the owner or operator of an Event.</span></span>
          </div>
          <div className="pos" id="_91:9153" style={{top: 9153, left: 91}}>
            <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
              11.3        <span style={{fontWeight: 'normal'}}> A Hayya D does not guarantee you access to an Event where you fail to comply with such requirements.</span></span>
          </div>
          <div className="pos" id="_91:9191" style={{top: 9191, left: 91}}>
            <span id="_14.2" style={{fontWeight: 'bold',  fontSize: '14.2px', color: '#000'}}>
              12.          Waiver and Release of Liability</span>
           
            <span id="_14.6" style={{ fontSize: '14.6px', color: '#000'}}>
              To the maximum extent permitted under the applicable law, you fully, irrevocably and unconditionally waive all </span>
          
            <span id="_14.0" style={{ fontSize: '14.0px', color: '#000'}}>
              claims against SC and all of its affiliated entities, each member association and confederation that is part of SC, and </span>
           
            <span id="_14.0" style={{ fontSize: '14.0px', color: '#000'}}>
              the officers, directors, agents, representatives, employees, elected and appointed officials of each of the foregoing </span>
           
            <span id="_14.5" style={{ fontSize: '14.5px', color: '#000'}}>
              entities (collectively, the “Indemnified Entities”) and agrees that the Indemnified Entities will have no liability or </span>
           
            <span id="_14.5" style={{ fontSize: '14.5px', color: '#000'}}>
              responsibility for any claim arising in connection with your Application, the Hayya ID/Services and/or the Hayya </span>
           
            <span id="_14.5" style={{ fontSize: '14.5px', color: '#000'}}>
              Mobile  App.  The  Indemnified  Entities  do  not  operate  and  have  no  control  over  your  Application,  the  Hayya </span>
           
            <span id="_14.0" style={{ fontSize: '14.0px', color: '#000'}}>
              ID/Services or the Mobile App. If you fail to obtain a Hayya ID or if your Application and/or Hayya ID is cancelled or </span>
           
            <span id="_14.0" style={{ fontSize: '14.0px', color: '#000'}}>
              terminated for any reason, you will not be entitled to any refunds from any of the Indemnified Entities in relation </span>
            
            <span id="_14.0" style={{ fontSize: '14.0px', color: '#000'}}>
              to your Event ticket.</span>
          </div>
          <div className="pos" id="_91:9602" style={{top: 9602, left: 91}}>
            <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000'}}>
              13.          Miscellaneous</span>
          </div>
          <div className="pos" id="_91:9640" style={{top: 9640, left: 91}}>
            <span id="_14.0" style={{fontWeight: 'bold',  fontSize: '14.0px', color: '#000'}}>
              13.1        Governing Law and Disputes: <span style={{fontWeight: 'normal'}}> These Terms and any disputes or claims arising out of or in connection with </span></span>
            <span id="_14.0" style={{ fontSize: '14.0px', color: '#000'}}>
              them  or  its  subject  matter  or  formation  (including  non-contractual  disputes  or  claims)  are  governed  by  and </span>
            <span id="_14.0" style={{ fontSize: '14.0px', color: '#000'}}>
              construed in accordance with the laws of the State of Qatar. Unless settled or otherwise agreed by both Parties, </span>
            <span id="_14.0" style={{ fontSize: '14.0px', color: '#000'}}>
              any dispute or difference shall be finally determined under the exclusive jurisdiction of the courts of the State of </span>
            <span id="_15.0" style={{ fontSize: '15.0px', color: '#000'}}>
              Qatar.</span>
          </div>
          <div className="pos" id="_91:9753" style={{top: 9753, left: 91}}>
            <span id="_13.9" style={{fontWeight: 'bold',  fontSize: '13.9px', color: '#000'}}>
              13.2        Assignment:<span style={{fontWeight: 'normal'}}> SC shall be free to assign or transfer any of its rights or obligations under these Terms at any </span></span>
            <span id="_13.9" style={{ fontSize: '13.9px', color: '#000'}}>
              time without your consent. You may not assign or transfer any of your rights or obligations.</span>
          </div>
          <div className="pos" id="_91:9810" style={{top: 9810, left: 91}}>
            <span id="_13.9" style={{fontWeight: 'bold',  fontSize: '13.9px', color: '#000'}}>
              13.3        Severance:<span style={{fontWeight: 'normal'}}> If any provision (or part of a provision) of these Terms are found by any court or administrative </span></span>
            <span id="_13.9" style={{ fontSize: '13.9px', color: '#000'}}>
              body of competent jurisdiction to be invalid, unenforceable or illegal, the other provisions shall remain in force. If </span>
            <span id="_13.9" style={{ fontSize: '13.9px', color: '#000'}}>
              any invalid, unenforceable or illegal provision would be valid, enforceable or legal if some part of it were deleted, </span>
            <span id="_13.9" style={{ fontSize: '13.9px', color: '#000'}}>
              the provision shall apply with whatever modification is necessary to give effect to our commercial intention.</span>
          </div>
          
          <div className="pos my-3 text-center" id="_408:10641" style={{top: 10641, left: 408}}>
            <span id="_18.5" style={{fontWeight: 'bold',  fontSize: '18.5px', color: '#000000'}}>
              Appendix 2</span>
          </div>
          <div className="pos" id="_380:10672" style={{top: 10672, left: 380}}>
            <span id="_18.5" style={{fontWeight: 'bold',  fontSize: '18.5px', color: '#000000'}}>
              Accreditation Terms</span>
          </div>
          <div className="pos" id="_91:10734" style={{top: 10734, left: 91}}>
            <span id="_12.3" style={{fontWeight: 'bold',  fontSize: '14.3px', color: '#000000'}}>
              <u>A</u><u>C</u><u>C</u><u>R</u><u>E</u><u>D</u><u>I</u><u>T</u><u>A</u><u>T</u><u>I</u><u>O</u><u>N</u><u> </u><u>T</u><u>E</u><u>R</u><u>M</u><u>S</u><u> </u><u>A</u><u>N</u><u>D</u><u> </u><u>C</u><u>O</u><u>N</u><u>D</u><u>I</u><u>T</u><u>I</u><u>O</u><u>N</u><u>S</u></span>
          </div>
          <div className="pos" id="_98:10768" style={{top: 10768, left: 98}}>
            <span id="_13.6" style={{fontWeight: 'bold',   color: '#000000'}}>
              1.</span>
          </div>
          <div className="pos" id="_146:10768" style={{top: 10768, left: 146}}>
            <span id="_12.2" style={{fontWeight: 'bold',  fontSize: '12.7px', color: '#000000'}}>
              Purpose and Scope</span>
          </div>
          <div className="pos" id="_91:10802" style={{top: 10802, left: 91}}>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              The following Accreditation T&amp;C are designed to ensure a correct and efficient functioning of the Accreditation </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              process relating to the Event. All Accreditations related to the event sites are subject to these Accreditation T&amp;C.</span>
          </div>
          <div className="pos" id="_98:10870" style={{top: 10870, left: 98}}>
            <span id="_13.6" style={{fontWeight: 'bold',   color: '#000000'}}>
              2.</span>
          </div>
          <div className="pos  mb-3" id="_146:10870" style={{top: 10870, left: 146}}>
            <span id="_12.5"className="text-decoration-underline" style={{fontWeight: 'bold',  fontSize: '12.5px', color: '#000000'}}>
              Definitions</span>
          </div>

<table style={{fontSize: "13.8px"}}>
  <tr>
    <td style={{padding: "10px"}}>Accreditation</td>
    <td style={{padding: "10px"}}>An individual and non-transferable right of access to one or more Zone(s) at an Accredited Site of the Event for a specified period, in accordance with the function(s) to be performed by the Accredited Party at the Event.</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>Accreditation Centre</td>
    <td style={{padding: "10px"}}>Any centre established at the Accredited Sites for issuing approved Accreditation Devices.</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>Accreditation Device</td>
    <td style={{padding: "10px"}}>The accreditation pass issued by the Organizer which confirms that the Accredited Party has been granted Accreditation by the organizer.</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>Accredited Sites</td>
    <td style={{padding: "10px"}}>Any area under the control of the Organizer for the Event which requires an Accreditation Device to gain access.</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>Accreditation Liaison Officer</td>
    <td style={{padding: "10px"}}>A   person   responsible   for   the   Accreditation  of   a   group   of   persons   within   an organisation/company, who submits Accreditation requests for the entire group.</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>Accreditation T&C</td>
    <td style={{padding: "10px"}}>The terms and conditions set out herein.</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>Accredited Party</td>
    <td style={{padding: "10px"}}>Any person granted Accreditation.</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>Applicable Data Protection Laws</td>
    <td style={{padding: "10px"}}>Any Qatari law and any other applicable law with respect to any Personal Data to which the Organizer is subject.</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>Applicant</td>
    <td style={{padding: "10px"}}>Any person wishing to receive an Accreditation and for whom an Accreditation request is made with the Organizer, either by such person directly or by an Accreditation Liaison Officer.</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>Application Form</td>
    <td style={{padding: "10px"}}>The official form to be completed and submitted pursuant to these Accreditation T&C in order to be considered for Accreditation.</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>Appointed Approver</td>
    <td style={{padding: "10px"}}>A  person  appointed  by  the  Organizer of the Event to  manage  all  requests  for  Accreditation  for  the Constituent Group for which they are responsible.</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>Broadcaster Information Centre</td>
    <td style={{padding: "10px"}}>The dedicated extranet website made available to Media Partners, providing them with information in relation to the Event.</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>Constituent Group</td>
    <td style={{padding: "10px"}}>Persons belonging to an Accreditation category or subcategory.</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>Event</td>
    <td style={{padding: "10px"}}>The FIFA Intercontinental Cup 2024TM</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>Identification Document</td>
    <td style={{padding: "10px"}}>A valid international passport or other personal identification document that is valid in the Country.</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>LOC</td>
    <td style={{padding: "10px"}}>The local organising committee formed for the purposes of the Event pursuant to Decision No 38 for the Year 2024 of the Executive Committee of the QFA.</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>Match</td>
    <td style={{padding: "10px"}}>Any official football match to be played as part of the Event, including extra time (if any) and penalty shoot-outs (if any).</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>Matchday</td>
    <td style={{padding: "10px"}}>The calendar day on which any Match takes place.</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}> Media Representative</td>
    <td style={{padding: "10px"}}>Any member of the press, photographers, internet editors, broadcasters and other media entities as determined by the Organizer (other than Media Partners).</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>Media Partners</td>
    <td style={{padding: "10px"}}>Those broadcasters and other media entities to which the Organizer has granted certain media rights to transmit the Matches and/or the ceremonies of the Event, and/or the Event (or parts thereof).</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>Organizer</td>
    <td style={{padding: "10px"}}>FIFA, QFA, the LOC and SC.</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>Permitted Publications</td>
    <td style={{padding: "10px"}}> (i) Wire services, printed newspapers, magazines and their supplements; and (ii) digital publications comparable to newspapers, magazines and their supplements (e.g. online newspapers or online magazines made available by way of websites, mobile sites, apps or social media), but excluding any related stand-alone digital products or services (such as update, alert, push and short-message services), whether provided to consumers directly or via operators or other intermediaries such as social media platforms.</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>Personal Data</td>
    <td style={{padding: "10px"}}>Any  information  identifying  an  Applicant  and  in  particular  the  personal  data  which  is submitted in and via the Application Form.</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>QFA</td>
    <td style={{padding: "10px"}}>Qatar Football Association, organized and existing under the laws of State of Qatar and whose principal place of business is at 28th Floor, Al Bidda Tower, West Bay, P.O. Box 5333, Doha, Qatar.</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>SC</td>
    <td style={{padding: "10px"}}>Supreme Committee for Delivery & Legacy, an entity established under the laws of the State of Qatar pursuant to Emiri Decree No. (27) of 2011 as amended by Emiri Decree No. (3) of 2014, and Emiri Decree No. 69 of 2024, whose place of business is Level 37, Al Bidda Tower, Al Corniche Street, West Bay, P.O. Box 62022, Doha, State of Qatar.</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>SC Privacy Policy</td>
    <td style={{padding: "10px"}}>The privacy policy that regulates the collection, processing and retention of personal data in each Application Form, which can be found at https://media.hayya.qa/privacy-policy.</td>
  </tr>
  <tr>
    <td style={{padding: "10px"}}>Zone</td>
    <td style={{padding: "10px"}}>A predefined space/area within an Accredited Site where access is limited to those holding the applicable Accreditation.</td>
  </tr>
</table>

          <div className="pos" id="_98:12158" style={{top: 12158, left: 98}}>
            <span id="_13.6" style={{fontWeight: 'bold',   color: '#000000'}}>
              3.</span>
          </div>
          <div className="pos" id="_148:12158" style={{top: 12158, left: 148}}>
            <span id="_12.4" style={{fontWeight: 'bold',  fontSize: '12.4px', color: '#000000'}}>
              Applying for Accreditation</span>
          </div>
          <div className="pos" id="_98:12192" style={{top: 12192, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              3.1. </span>
          </div>
          <div className="pos" id="_146:12192" style={{top: 12192, left: 146}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              Application Forms can be submitted either by the Applicant directly or by an Accreditation Liaison Officer </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              submitting Application Forms on behalf of various Applicants.</span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              Accreditation must be requested strictly in accordance with the functions to be performed </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              by the relevant Applicant during the Event.</span>
          </div>
          <div className="pos" id="_98:12277" style={{top: 12277, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              3.2. </span>
          </div>
          <div className="pos" id="_146:12277" style={{top: 12277, left: 146}}>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              Unless otherwise determined by the Organizer, Application Forms must be submitted via the internet </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              (through such link made available, or such channels as determined, by the Organizer). Only Application </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              Forms  that  are  fully  completed  and  submitted  to  the  Organizer  by  the  established  deadline  will  be </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              processed. Application Forms that are incomplete, unclear or late will be rejected.</span>
          </div>
          <div className="pos" id="_98:12361" style={{top: 12361, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              3.3. </span>
          </div>
          <div className="pos" id="_146:12361" style={{top: 12361, left: 146}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              By completing the Application Form, Applicants warrant and declare that</span>
          </div>
         <div className="px-5"> 
          <div className="pos" id="_146:12378" style={{top: 12378, left: 146}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (i)</span>
          </div>
          <div className="pos" id="_196:12378" style={{top: 12378, left: 196}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              they have read and understood these Accreditation T&amp;C;</span>
          </div>
          <div className="pos" id="_146:12395" style={{top: 12395, left: 146}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (ii)</span>
          </div>
          <div className="pos" id="_196:12395" style={{top: 12395, left: 196}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              they are fully aware of the rights and obligations arising therefrom;</span>
          </div>
          <div className="pos" id="_146:12412" style={{top: 12412, left: 146}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (iii)</span>
          </div>
          <div className="pos" id="_196:12412" style={{top: 12412, left: 196}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              they accept and agree to comply with these Accreditation T&amp;C;</span>
          </div>
          <div className="pos" id="_146:12429" style={{top: 12429, left: 146}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (iv)</span>
          </div>
          <div className="pos" id="_196:12429" style={{top: 12429, left: 196}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              they accept and agree to comply with all Covid-19 related requirements of the Organizer; and</span>
          </div>
          <div className="pos" id="_146:12446" style={{top: 12446, left: 146}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (v)</span>
          </div>
          <div className="pos" id="_196:12446" style={{top: 12446, left: 196}}>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              they grant the Organizer their consent to their Personal Data being processed as set out in </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              Clause 11 of these Accreditation T&amp;C.</span>
          </div>
          </div>
          <div className="pos" id="_98:12497" style={{top: 12497, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              3.4. </span>
          </div>
          <div className="pos" id="_146:12497" style={{top: 12497, left: 146}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              Accreditation Liaison Officers additionally warrant and declare that</span>
          </div>
         <div className="px-5">
           <div className="pos" id="_146:12513" style={{top: 12513, left: 146}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (i)</span>
          </div>
          <div className="pos" id="_196:12513" style={{top: 12513, left: 196}}>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              they have provided these Accreditation T&amp;C to all Applicants for whom they are submitting </span>
          
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              Accreditation applications;</span>
          </div>
          <div className="pos" id="_146:12547" style={{top: 12547, left: 146}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (ii)</span>
          </div>
          <div className="pos" id="_196:12547" style={{top: 12547, left: 196}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              all such Applicants have read and accepted these Accreditation T&amp;C; and</span>
          </div>
          <div className="pos" id="_146:12564" style={{top: 12564, left: 146}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (iii)</span>
          </div>
          <div className="pos" id="_196:12564" style={{top: 12564, left: 196}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              they will ensure that all such Applicants comply with these Accreditation T&amp;C.</span>
          </div>
          </div>
          <div className="pos" id="_98:12598" style={{top: 12598, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              3.5. </span>
          </div>
          <div className="pos" id="_146:12598" style={{top: 12598, left: 146}}>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              The Organizer is not liable for the incorrect entry of information by the Applicant or the Accreditation </span>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              Liaison Officer, as the case may be, technical malfunctions of the internet, or any failure of computer </span>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              hardware or software.</span>
          </div>
          <div className="pos" id="_98:12666" style={{top: 12666, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              3.6. </span>
          </div>
          <div className="pos" id="_146:12666" style={{top: 12666, left: 146}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              The right of Accreditation is subject to an Applicant having read and agreed to, and at all times complying </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              with,  the  Organizer  Code  of  Conduct  and  the  Standards  of  Conduct  Policy  applicable  to  Accredited </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              Parties for the Event, which forms an integral part of the application process and shall remain available </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              to Accredited Parties upon request.</span>
          </div>
          <div className="pos" id="_98:12750" style={{top: 12750, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              3.7. </span>
          </div>
          <div className="pos" id="_146:12750" style={{top: 12750, left: 146}}>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              Neither an Accreditation Device nor the right of Accreditation granted by the Organizer constitutes a </span>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              travel visa or any other authorisation to travel to or work in the Host Country. It is the sole responsibility</span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              of the Applicant to ensure that they have obtained all applicable authorizations required by local laws to travel to </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              the Host Country and perform the functions for which they have been or seek to be granted  Accreditation. The </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              Organizer accept no liability for any failure or delay by the Applicant in obtaining any  such authorizations.</span>
          </div>
          <div className="pos" id="_98:13036" style={{top: 13036, left: 98}}>
            <span id="_13.6" style={{fontWeight: 'bold',   color: '#000000'}}>
              4.</span>
          </div>
          <div className="pos" id="_148:13036" style={{top: 13036, left: 148}}>
            <span id="_12.3" style={{fontWeight: 'bold',  fontSize: '14.3px', color: '#000000'}}>
              Process for Granting Accreditation</span>
          </div>
          <div className="pos" id="_98:13070" style={{top: 13070, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              4.1. </span>
          </div>
          <div className="pos" id="_146:13070" style={{top: 13070, left: 146}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              Accreditation  applications  will  be  subject  to  a  screening  process,  after  which  the  Organizer  will </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              determine the appropriate Accreditation in each case (if any). The Organizer reserves the right to turn </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              down any application. Decisions made by the Organizer have binding force. The Organizer decision is </span>
            <span id="_13.2" style={{ fontSize: '13.2px', color: '#000000'}}>
              final and Applicants are not permitted to resubmit an application for an Accreditation that has been </span>
            <span id="_13.6" style={{  color: '#000000'}}>
              rejected.</span>
          </div>
          <div className="pos" id="_98:13172" style={{top: 13172, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              4.2. </span>
          </div>
          <div className="pos" id="_146:13172" style={{top: 13172, left: 146}}>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              The Organizer reserves the right to amend or limit an Accreditation and will notify the Accredited Party </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              accordingly.</span>
          </div>
          <div className="pos" id="_98:13223" style={{top: 13223, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              4.3. </span>
          </div>
          <div className="pos" id="_146:13223" style={{top: 13223, left: 146}}>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              The Accredited Party will be provided with one Accreditation Device. The Accreditation Device can be </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              collected  upon  presentation  of  the  Identification  Document  stated  on  the  Application  Form.  Upon </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              collection of the Accreditation Device, the Accredited Party (or the Accreditation Liaison Officer or other </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              authorised representative acting on behalf of the Accredited Party) must sign a separate form to confirm</span>
          </div>
          <div className="pos" id="_146:13290" style={{top: 13290, left: 146}}>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              (i) the receipt of the Accreditation Device, (ii) the Accredited Party’s acceptance of and compliance with </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              these Accreditation T&amp;C, (iii) any warranties and indemnities given under these Accreditation T&amp;C, and</span>
          </div>
          <div className="pos" id="_91:13324" style={{top: 13324, left: 91}}>
            <span id="_12.5" style={{ fontSize: '12.5px', color: '#000000'}}>
              (iv) the Accredited Party’s consent to their Personal Data being processed as set out in Clause 11 of these </span>
            <span id="_12.5" style={{ fontSize: '12.5px', color: '#000000'}}>
              Accreditation T&amp;C. All Accreditation Devices remain at all times the property of the Organizer.</span>
          </div>
          <div className="pos mt-2" id="_98:13374" style={{top: 13374, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              4.4. </span>
          </div>
          <div className="pos" id="_146:13374" style={{top: 13374, left: 146}}>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              The Organizer reserves the right to unilaterally revoke the Accreditation of any Accredited Party. The </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              Accreditation  will  be  revoked  in  any  case  if  it  appears  that  (i)  any  changes  have  been  made  to  the </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              Accreditation Device (unless made by representatives of the Organizer), (ii) the Accreditation Device was </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              not obtained following the official application process, and/or (iii) the Accredited Party does not comply </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              with these Accreditation T&amp;C. The Organizer additionally reserves the right to unilaterally revoke the </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              Accreditation of any Accredited Party in the event that the circumstances which qualified the Accredited </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              Party  to  obtain  Accreditation  are  no  longer  applicable.  Revocation  of  Accreditation  renders  the </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              Accreditation Device invalid, which means that the Accredited Party’s right to access the Accredited Sites </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              will  be  denied  and  the  Accredited  Party  must  return  the  Accreditation  Device  to  the  Organizer </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              immediately.</span>
          </div>
          <div className="pos mt-2" id="_98:13559" style={{top: 13559, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              4.5. </span>
          </div>
          <div className="pos" id="_146:13559" style={{top: 13559, left: 146}}>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              In the event that the Accreditation Device is lost or stolen, the Organizer shall decide whether a new </span>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              Accreditation  Device  is  to  be  issued.  This  requires  the  Accredited  Party  to  adhere  to  the  following </span>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              procedure:</span>
          </div>
          <div className="pos" id="_91:13627" style={{top: 13627, left: 91}}>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              <u>I</u><u>n</u><u> </u><u>t</u><u>h</u><u>e</u><u> </u><u>e</u><u>v</u><u>e</u><u>n</u><u>t</u><u> </u><u>o</u><u>f</u><u> </u><u>t</u><u>h</u><u>e</u><u>f</u><u>t</u><u>:</u></span>
          </div>
          <div className="pos" id="_148:13644" style={{top: 13644, left: 148}}>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              -<span style={{fontFamily: 'Arial'}}> Any theft must be reported to the police within 24 hours of its detection.</span></span>
          </div>
          <div className="pos" id="_148:13661" style={{top: 13661, left: 148}}>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              -<span style={{fontFamily: 'Arial'}}> The issued theft notification must be presented at an Accreditation Centre.</span></span>
          </div>
          <div className="pos" id="_91:13695" style={{top: 13695, left: 91}}>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              <u>I</u><u>n</u><u> </u><u>t</u><u>h</u><u>e</u><u> </u><u>e</u><u>v</u><u>e</u><u>n</u><u>t</u><u> </u><u>o</u><u>f</u><u> </u><u>l</u><u>o</u><u>s</u><u>s</u><u>:</u></span>
          </div>
          <div className="pos" id="_148:13712" style={{top: 13712, left: 148}}>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              -<span style={{fontFamily: 'Arial'}}> Loss of any Accreditation Device must be reported to an Accreditation Centre within 24 hours of its </span></span>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              detection.</span>
          </div>
          <div className="pos mt-2" id="_91:13762" style={{top: 13762, left: 91}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              In case of theft or loss, the Organizer is not obliged to issue a new Accreditation Device.</span>
          </div>
          <div className="pos" id="_98:13796" style={{top: 13796, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              4.6. </span>
          </div>
          <div className="pos" id="_146:13796" style={{top: 13796, left: 146}}>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              If an Accredited Party is to be replaced by another person, the Accredited Party or the Accreditation </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              Liaison Officer responsible for such Accredited Party must submit a written request to the respective </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              Appointed Approver. The request must clearly state the reason for the substitution. It must also specify </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              all  the  information  of  the  current  Accredited  Party,  including  the  registration  number  of  the </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              Accreditation applied for and the relevant details of the substitute Applicant. Where an Accreditation </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              Device has already been handed out to the current Accredited Party, such Accreditation Device must be </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              returned  to  an  Accreditation  Centre  or  the  respective  Appointed  Approver.  The  new  Accreditation </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              Device will not be issued to the substitute Applicant until such current Accreditation Device has been </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              returned. The Organizer reserves the right, at its sole discretion, to refuse the proposed substitution for any reason </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              whatsoever,  or  to  limit  the  scope  of  the  Accreditation  granted  to  the  substitute  Applicant  in  any  manner </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              whatsoever.</span>
          </div>
          <div className="pos" id="_98:14206" style={{top: 14206, left: 98}}>
            <span id="_13.6" style={{fontWeight: 'bold',   color: '#000000'}}>
              5.</span>
          </div>
          <div className="pos" id="_148:14206" style={{top: 14206, left: 148}}>
            <span id="_12.4" style={{fontWeight: 'bold',  fontSize: '12.4px', color: '#000000'}}>
              Using the Accreditation</span>
          </div>
          <div className="pos" id="_98:14240" style={{top: 14240, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              5.1. </span>
          </div>
          <div className="pos" id="_146:14240" style={{top: 14240, left: 146}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              The Accreditation Device is personal and non-transferable and may not be commercialized. Accredited </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              Parties may not sell or otherwise transfer their Accreditation or use their Accreditation jointly with third </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              parties. Accredited Parties are strictly prohibited from photographing, posting and/or sharing images of </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              their Accreditation Device online or via social media, or knowingly permitting any third party to do the </span>
            <span id="_13.6" style={{  color: '#000000'}}>
              same.</span>
          </div>
          <div className="pos" id="_98:14342" style={{top: 14342, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              5.2. </span>
          </div>
          <div className="pos" id="_146:14342" style={{top: 14342, left: 146}}>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              Accredited  Parties  must  use  the  Accreditation  Device  solely  to  fulfil  the  functions  that  are  to  be </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              performed by them during the Event and for which such Accreditation Device has been issued. Each </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              Accredited Party is permitted access to the Accredited Sites and Zones only for the duration indicated </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              on the respective Accreditation Device.</span>
          </div>
          <div className="pos" id="_98:14426" style={{top: 14426, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              5.3. </span>
          </div>
          <div className="pos" id="_146:14426" style={{top: 14426, left: 146}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              Access to an Accredited Site shall only be granted upon presentation of a valid Accreditation Device and, </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              upon request by the security staff, a valid Identification Document. The Accredited Party present at the </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              Accredited  Site  must  display  the  Accreditation  Device  clearly  at  all  times  and  always  carry  a  valid </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              Identification Document.</span>
          </div>
          <div className="pos" id="_98:14511" style={{top: 14511, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (iv)</span>
          </div>
          <div className="text-sm-letter">
          <div className="pos " id="_146:14511" style={{top: 14511, left: 146}}>
            <span id="_12.2" style={{ fontSize: '12.7px', color: '#000000'}}>
              ALL ACCREDITED PARTIES ACKNOWLEDGE THAT THEY SHALL MOVE IN AND AROUND AN ACCREDITED </span>
            <span id="_12.2" style={{ fontSize: '12.7px', color: '#000000'}}>
              SITE AT  THEIR  OWN  RISK. ALL  ACCREDITED  PARTIES  ALSO  ACKNOWLEDGE  AND  ACCEPT  THAT  BY </span>
            <span id="_12.2" style={{ fontSize: '12.7px', color: '#000000'}}>
              ENTERING  ANY  ACCREDITED  SITE,  THERE  MAY  BE  AN  INCREASED  RISK  OF  EXPOSURE  TO  COVID-19 </span>
            <span id="_12.2" style={{ fontSize: '12.7px', color: '#000000'}}>
              AND/OR OTHER INFECTIOUS DISEASES. IN THE EVENT OF THE OCCURRENCE OF AN INCIDENT WHICH </span>
            <span id="_12.2" style={{ fontSize: '12.7px', color: '#000000'}}>
              CAUSES  DAMAGE  OR  LOSS  INVOLVING  (I)  INJURY  CAUSING  DEATH,  (II)  BODILY  INJURY,  OR  (III) </span>
            <span id="_12.2" style={{ fontSize: '12.7px', color: '#000000'}}>
              PERMANENT  DAMAGE  TO  HEALTH,  THE  ORGANIZER  SHALL  ONLY  BE  LIABLE  IF  ANY  OF  THEIR </span>
            <span id="_12.2" style={{ fontSize: '12.7px', color: '#000000'}}>
              AUTHORISED  REPRESENTATIVES  OR  AGENTS  CAUSED  SUCH  DAMAGE  OR  LOSS  THROUGH  THEIR </span>
            <span id="_12.2" style={{ fontSize: '12.7px', color: '#000000'}}>
              NEGLIGENCE OR WILFUL INTENT, TO THE MAXIMUM EXTENT PERMITTED UNDER APPLICABLE LAW. IN </span>
            <span id="_12.2" style={{ fontSize: '12.7px', color: '#000000'}}>
              RESPECT OF ALL OTHER INCIDENTS CAUSING OTHER DAMAGE OR LOSS, THE ORGANIZER SHALL ONLY BE </span>
            <span id="_12.2" style={{ fontSize: '12.7px', color: '#000000'}}>
              LIABLE FOR DAMAGE AND/OR LOSS SUFFERED BY THE ACCREDITED PARTY IF SUCH DAMAGE AND/OR </span>
            <span id="_12.2" style={{ fontSize: '12.7px', color: '#000000'}}>
              LOSS  HAS  BEEN  CAUSED  BY  THE  GROSS  NEGLIGENCE  OR  WILFUL  INTENT  OF  THE  ORGANIZER’S </span>
            <span id="_12.2" style={{ fontSize: '12.7px', color: '#000000'}}>
              AUTHORISED REPRESENTATIVES OR AGENTS. TO THE MAXIMUM EXTENT PERMITTED UNDER APPLICABLE </span>
            <span id="_12.2" style={{ fontSize: '12.7px', color: '#000000'}}>
              LAW,  IN  NO  EVENT  SHALL  THE  ORGANIZER  WILL  BE  LIABLE  FOR  ANY  SPECIAL,  CONSEQUENTIAL, </span>
            <span id="_12.2" style={{ fontSize: '12.7px', color: '#000000'}}>
              INCIDENTAL, INDIRECT OR PUNITIVE DAMAGES OF ANY KIND.</span>
          </div>
          </div>
          <div className="pos" id="_98:14765" style={{top: 14765, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (v)</span>
          </div>
          <div className="pos" id="_146:14765" style={{top: 14765, left: 146}}>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              Access to an Accredited Site will be refused to any person noticeably under the influence of alcohol, </span>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              narcotics or any behaviour-modifying substance, or to any person behaving or deemed likely to behave </span>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              violently, harmfully or in a manner contrary to public order. Furthermore, access will be refused to any </span>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              person whose appearance or behaviour is deemed likely to negatively affect the public standing of the </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              Organizer.</span>
          </div>
          <div className="pos" id="_98:14866" style={{top: 14866, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (vi)</span>
          </div>
          <div className="pos" id="_146:14866" style={{top: 14866, left: 146}}>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              All persons at an Accredited Site are strictly prohibited from using, displaying or possessing with the </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              intent to display promotional or commercial, political, religious, offensive or discriminatory objects and </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              materials, as well as from offering to sell, selling or possessing with intent to sell goods such as drinks, </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              food,  tobacco/vaping  products,  souvenirs,  clothes,  promotional  and/or  commercial  items  unless </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              approved in advance by the Organizer in writing.</span>
          </div>
          <div className="pos" id="_98:14967" style={{top: 14967, left: 98}}>
            <span id="_13.6" style={{fontWeight: 'bold',   color: '#000000'}}>
              6.</span>
          </div>
          <div className="pos" id="_148:14967" style={{top: 14967, left: 148}}>
            <span id="_12.2" style={{fontWeight: 'bold',  fontSize: '12.7px', color: '#000000'}}>
              Safety and Security Provisions</span>
          </div>
          <div className="pos" id="_98:15001" style={{top: 15001, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (i)</span>
          </div>
          <div className="pos" id="_146:15001" style={{top: 15001, left: 146}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              Accredited  Parties  must,  at  all  times  in  and  around  an  Accredited  Site,  comply  with  the  safety  and </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              security  provisions  of  the  present  Clause  and  with  any  instructions  given  by  the  stewards,  security </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              personnel and any other person duly authorised to give such instructions at an Accredited Site acting at </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              their absolute discretion.</span>
          </div>
          <div className="pos" id="_98:15086" style={{top: 15086, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (ii)</span>
          </div>
          <div className="pos text-sm-letter" id="_146:15086" style={{top: 15086, left: 146}}>
            <span id="_12.0" style={{ fontSize: '12.7px', color: '#000000'}}>
              In ORDER TO ATTEMPT TO REDUCE THE SPREAD OF OR THE RISK OF CONTRACTING CERTAIN INFECTIOUS </span>
            <span id="_12.0" style={{ fontSize: '12.7px', color: '#000000'}}>
              DISEASES, SUCH AS COVID-19, THE ORGANIZER MAY ADOPT RULES AND PROTOCOLS APPLICABLE TO</span>
            <span id="_12.3" style={{ fontSize: '12.7px', color: '#000000'}}>
              ANY ACCREDITED SITE WHICH ACCREDITED PARTIES AGREE TO ABIDE BY AT ALL TIMES. DUE TO THE EVOLVING </span>
            <span id="_12.3" style={{ fontSize: '12.7px', color: '#000000'}}>
              UNDERSTANDING  ABOUT  APPROPRIATE  AND  EFFECTIVE  METHODS  TO  REDUCE  THE  RISK  OF  SPREADING  OR </span>
            <span id="_12.3" style={{ fontSize: '12.7px', color: '#000000'}}>
              CONTRACTING CERTAIN INFECTIOUS DISEASES, INCLUDING COVID-19, SUCH RULES AND  PROTOCOLS  MAY  BE </span>
            <span id="_12.3" style={{ fontSize: '12.7px', color: '#000000'}}>
              PROVIDED  TO  ACCREDITED  PARTIES  AT  ANY  TIME  AND  REMAIN  SUBJECT  TO CHANGE. ANY NON-COMPLIANCE </span>
            <span id="_12.3" style={{ fontSize: '12.7px', color: '#000000'}}>
              WITH  SUCH  RULES  AND  PROTOCOLS  MAY  RESULT  IN  AN  ACCREDITED  PARTY  BEING  REMOVED  FROM  AN </span>
            <span id="_12.3" style={{ fontSize: '12.7px', color: '#000000'}}>
              ACCREDITED SITE AND THEIR ACCREDITATION DEVICE BEING CONFISCATED. BY ENTERING ANY ACCREDITED SITE, </span>
            <span id="_12.3" style={{ fontSize: '12.7px', color: '#000000'}}>
              EACH ACCREDITED PARTY VOLUNTARILY ASSUMES  ALL RISKS RELATED TO EXPOSURE TO COVID-19.</span>
          </div>
          <div className="pos" id="_98:15444" style={{top: 15444, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (iii)</span>
          </div>
          <div className="pos" id="_146:15444" style={{top: 15444, left: 146}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              Each  Accredited  Party  is  obliged  to  (i)  present  a  valid  Accreditation  Device  and/or  Identification </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              Document upon demand, (ii) submit to body searches and searches of any bags or other containers </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              which the Accredited Party is seeking to bring and/or has brought into the Accredited Site(s), and (iii) </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              consent to the confiscation of prohibited items. Accredited Parties shall be obliged, upon request, to </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              give an explanation as to how, from whom and from where their Accreditation Devices were obtained.</span>
          </div>
          <div className="pos" id="_98:15545" style={{top: 15545, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (iv)</span>
          </div>
          <div className="pos" id="_146:15545" style={{top: 15545, left: 146}}>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              The following is a non-exhaustive, indicative list of items which Accredited Parties are forbidden to use </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              or bring into an Accredited Site unless otherwise authorised by the Organizer:<br/></span>
            <span id="_11.9" style={{ fontSize: '11.9px', color: '#000000'}}>
              <span id="_12.9" style={{ fontSize: '12.9px'}}> weapons of any kind;</span></span>
            <span id="_11.9" style={{ fontSize: '11.9px', color: '#000000'}}>
              &nbsp;<span id="_12.9" style={{ fontSize: '12.9px'}}> anything that could be used as a weapon or to cut, thrust or stab, or as a projectile, in particular </span></span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              long umbrellas and other unwieldy implements;</span>
            <span id="_11.9" style={{ fontSize: '11.9px', color: '#000000'}}>
              &nbsp;<span id="_12.9" style={{ fontSize: '12.9px'}}> hard cooler boxes (branded or unbranded); as well as bottles, cups, jugs or cans made of glass </span></span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              and/or  that  display  any  prominent  branding  other  than  branding  of  the  Event  or  approved </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              commercial affiliates;</span>
            <span id="_11.9" style={{ fontSize: '11.9px', color: '#000000'}}>
              &nbsp;<span id="_12.9" style={{ fontSize: '12.9px'}}> fireworks, flares, smoke powder, smoke canisters, smoke bombs or other pyrotechnics;</span></span>
            <span id="_11.9" style={{ fontSize: '11.9px', color: '#000000'}}>
              &nbsp;<span id="_12.9" style={{ fontSize: '12.9px'}}> alcoholic beverages of any kind, narcotics or stimulants;</span></span>
            <span id="_11.9" style={{ fontSize: '11.9px', color: '#000000'}}>
              &nbsp;<span id="_12.9" style={{ fontSize: '12.9px'}}> discriminatory materials of any kind against a country, person or group based on race, skin colour, </span></span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              ethnic, national or social origin, gender, disability, language, religion, political opinion or any other </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              opinion, birth, wealth or any other status, sexual orientation or any other grounds, including but </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              not  limited  to  banners,  signs,  symbols  and  leaflets,  objects  or  clothing,  which  could  impair  the </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              enjoyment of the Event by others or detract from the sporting focus of the Event;</span>
            <span id="_11.9" style={{ fontSize: '11.9px', color: '#000000'}}>
              &nbsp;<span id="_12.9" style={{ fontSize: '12.9px'}}> flagpoles or banner poles of any kind;</span></span>
            <span id="_11.9" style={{ fontSize: '11.9px', color: '#000000'}}>
              &nbsp;<span id="_12.9" style={{ fontSize: '12.9px'}}> banners or flags of any kind larger than 1.5m x 2m;</span></span>
            <span id="_11.9" style={{ fontSize: '11.9px', color: '#000000'}}>
              &nbsp;<span id="_12.9" style={{ fontSize: '12.9px'}}> any type of animal, except for assistance dogs, provided that they are not prohibited under local</span><span id="_12.9" style={{ fontSize: '12.9px'}}> </span></span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              laws. Assistance dogs shall only be permitted if they are accompanying a disabled Accredited Party. </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              In such cases, the Accredited Party intending to bring and use an assistance dog may be required </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              to present such official documentation or notarised copies thereof which (i) provide(s) proof of </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              their disability justifying the need for an assistance dog, and (ii) evidence(s) the qualification of the </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              dog as an assistance dog, within the parameters established by applicable rules;</span>
            <span id="_11.9" style={{ fontSize: '11.9px', color: '#000000'}}>
              &nbsp;<span id="_12.9" style={{ fontSize: '12.9px'}}> any promotional or commercial materials, including but not limited to signs, symbols and leaflets, </span></span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              or any kind of promotional or commercial objects, material and clothing;</span>
            <span id="_11.9" style={{ fontSize: '11.9px', color: '#000000'}}>
              &nbsp;<span id="_12.9" style={{ fontSize: '12.9px'}}> gas spray cans, corrosive, flammable substances, dyes or receptacles containing substances which </span></span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              are harmful to health or are highly flammable;</span>
            <span id="_11.9" style={{ fontSize: '11.9px', color: '#000000'}}>
              &nbsp;<span id="_12.9" style={{ fontSize: '12.9px'}}> large quantities of paper and/or rolls of paper;</span></span>
            <span id="_11.9" style={{ fontSize: '11.9px', color: '#000000'}}>
              &nbsp;<span id="_12.9" style={{ fontSize: '12.9px'}}> mechanically </span><span id="_12.9" style={{ fontSize: '12.9px'}}> operated </span><span id="_12.9" style={{ fontSize: '12.9px'}}> instruments </span><span id="_12.9" style={{ fontSize: '12.9px'}}> which </span><span id="_12.9" style={{ fontSize: '12.9px'}}> produce </span><span id="_12.9" style={{ fontSize: '12.9px'}}> an </span><span id="_12.9" style={{ fontSize: '12.9px'}}> excessive </span><span id="_12.9" style={{ fontSize: '12.9px'}}> volume </span><span id="_12.9" style={{ fontSize: '12.9px'}}> of </span><span id="_12.9" style={{ fontSize: '12.9px'}}> noise </span><span id="_12.9" style={{ fontSize: '12.9px'}}> such </span><span id="_12.9" style={{ fontSize: '12.9px'}}> as </span></span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              megaphones, hooters or gas-powered horns;</span>
            <span id="_11.9" style={{ fontSize: '11.9px', color: '#000000'}}>
              &nbsp;<span id="_12.9" style={{ fontSize: '12.9px'}}> drones and similar types of flying and recording devices;</span></span>
            <span id="_11.9" style={{ fontSize: '11.9px', color: '#000000'}}>
              &nbsp;<span id="_12.9" style={{ fontSize: '12.9px'}}> laser pointers;</span></span>
            <span id="_11.9" style={{ fontSize: '11.9px', color: '#000000'}}>
              &nbsp;<span id="_12.9" style={{ fontSize: '12.9px'}}> cameras or any other sound or video recording equipment, except (i) for private use and then only </span></span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              with one set of replacement or rechargeable batteries, or (ii) to the extent the use of such devices </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              by accredited Media Partners or Media Representatives is permitted under Clause 8 below; </span>
            <span id="_13.6" style={{  color: '#000000'}}>
              and/or</span>
            <span id="_12.0" style={{ fontSize: '12.7px', color: '#000000'}}>
              &nbsp;<span id="_13.0" style={{ fontSize: '13.0px'}}> other objects which could compromise public safety and/or harm the reputation of the Event, the </span></span>
            <span id="_12.5" style={{ fontSize: '12.5px', color: '#000000'}}>
              Organizer, as assessed at the sole discretion of the Organizer.</span>
            <span id="_12.5" style={{ fontSize: '12.5px', color: '#000000'}}>
              All decisions regarding any items carried by any Accredited Party at an Accredited Site shall be at the  absolute </span>
            <span id="_12.5" style={{ fontSize: '12.5px', color: '#000000'}}>
              discretion of the stewards, security personnel, and/or any other duly authorised persons.</span>
          </div>
          <div className="pos" id="_98:16479" style={{top: 16479, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (v)</span>
          </div>
          <div className="pos" id="_146:16479" style={{top: 16479, left: 146}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              All Accredited Parties shall, at all times during their stay at an Accredited Site, conduct themselves in a </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              manner so as not to offend, discriminate against, endanger the safety of, or unnecessarily hinder or </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              harass other Accredited Parties and/or any other person.</span>
          </div>
          <div className="pos" id="_98:16546" style={{top: 16546, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (vi)</span>
          </div>
          <div className="pos" id="_146:16546" style={{top: 16546, left: 146}}>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              All  Accredited  Parties,  if  applicable  and  only  to  the  extent  in  accordance  with  the  function  to  be </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              performed by them at the Event, must occupy only the places in designated areas as indicated on their </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              Accreditation Device and/or dedicated media spaces defined by the Organizer, and shall access them </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              only via the designated entrance(s) unless otherwise directed by the Organizer. Accredited Parties shall </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              move to places other than those in the designated areas if instructed to do so by the Organizer.</span>
          </div>
          <div className="pos" id="_98:16647" style={{top: 16647, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (vii)</span>
          </div>
          <div className="pos" id="_146:16647" style={{top: 16647, left: 146}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              All access stairways (if any) and emergency exits must be kept clear at all times.</span>
          </div>
          <div className="pos" id="_98:16681" style={{top: 16681, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (viii)</span>
          </div>
          <div className="pos" id="_146:16681" style={{top: 16681, left: 146}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              All Accredited Parties are requested not to drop litter, packaging or empty containers, but to dispose of </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              such items in the appropriate litter bins.</span>
          </div>
          <div className="pos" id="_98:16732" style={{top: 16732, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (ix)</span>
          </div>
          <div className="pos" id="_146:16732" style={{top: 16732, left: 146}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              In accordance with the Organizer Event Policy on Tobacco, smoking (including vaping) is only permitted </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              in outdoor designated smoking areas (if they are made available) as determined by the Organizer and </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              local laws.</span>
          </div>
          <div className="pos" id="_98:16800" style={{top: 16800, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (x)</span>
          </div>
          <div className="pos" id="_146:16800" style={{top: 16800, left: 146}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              Unless otherwise authorised by the Organizer, Accredited Parties shall not:</span>
          </div>
          <div className="pos" id="_148:16815" style={{top: 16815, left: 148}}>
            <span id="_11.7" style={{ fontSize: '11.7px', color: '#000000'}}>
            •<span id="_12.7" style={{ fontSize: '12.7px'}}> enter any area, whether before, during or after the Event, for which access has not been granted </span></span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              as indicated on their respective Accreditation Device;</span>
          </div>
          <div className="pos" id="_148:16850" style={{top: 16850, left: 148}}>
            <span id="_11.7" style={{ fontSize: '11.7px', color: '#000000'}}>
            •<span id="_12.7" style={{ fontSize: '12.7px'}}> stand on seats in the spectator areas or unreasonably obstruct the view of others;</span></span>
          </div>
          <div className="pos" id="_148:16867" style={{top: 16867, left: 148}}>
            <span id="_11.7" style={{ fontSize: '11.7px', color: '#000000'}}>
            •<span id="_12.7" style={{ fontSize: '12.7px'}}> throw </span><span id="_12.7" style={{ fontSize: '12.7px'}}> objects </span><span id="_12.7" style={{ fontSize: '12.7px'}}> or </span><span id="_12.7" style={{ fontSize: '12.7px'}}> liquids </span><span id="_12.7" style={{ fontSize: '12.7px'}}> of </span><span id="_12.7" style={{ fontSize: '12.7px'}}> any </span><span id="_12.7" style={{ fontSize: '12.7px'}}> kind, </span><span id="_12.7" style={{ fontSize: '12.7px'}}> particularly </span><span id="_12.7" style={{ fontSize: '12.7px'}}> in </span><span id="_12.7" style={{ fontSize: '12.7px'}}> the </span><span id="_12.7" style={{ fontSize: '12.7px'}}> direction </span><span id="_12.7" style={{ fontSize: '12.7px'}}> of </span><span id="_12.7" style={{ fontSize: '12.7px'}}> another </span><span id="_12.7" style={{ fontSize: '12.7px'}}> person </span><span id="_12.7" style={{ fontSize: '12.7px'}}> or </span><span id="_12.7" style={{ fontSize: '12.7px'}}> in </span><span id="_12.7" style={{ fontSize: '12.7px'}}> the </span></span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              direction of the area around the stage or the stage itself;</span>
          </div>
          <div className="pos" id="_148:16902" style={{top: 16902, left: 148}}>
            <span id="_11.7" style={{ fontSize: '11.7px', color: '#000000'}}>
            •<span id="_12.7" style={{ fontSize: '12.7px'}}> start </span><span id="_12.7" style={{ fontSize: '12.7px'}}> a </span><span id="_12.7" style={{ fontSize: '12.7px'}}> fire, </span><span id="_12.7" style={{ fontSize: '12.7px'}}> or </span><span id="_12.7" style={{ fontSize: '12.7px'}}> let </span><span id="_12.7" style={{ fontSize: '12.7px'}}> off </span><span id="_12.7" style={{ fontSize: '12.7px'}}> or </span><span id="_12.7" style={{ fontSize: '12.7px'}}> launch </span><span id="_12.7" style={{ fontSize: '12.7px'}}> fireworks, </span><span id="_12.7" style={{ fontSize: '12.7px'}}> flares, </span><span id="_12.7" style={{ fontSize: '12.7px'}}> smoke </span><span id="_12.7" style={{ fontSize: '12.7px'}}> powder, </span><span id="_12.7" style={{ fontSize: '12.7px'}}> smoke </span><span id="_12.7" style={{ fontSize: '12.7px'}}> bombs </span><span id="_12.7" style={{ fontSize: '12.7px'}}> or </span><span id="_12.7" style={{ fontSize: '12.7px'}}> other </span></span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              pyrotechnics;</span>
          </div>
          <div className="pos" id="_148:16937" style={{top: 16937, left: 148}}>
            <span id="_11.7" style={{ fontSize: '11.7px', color: '#000000'}}>
            •<span id="_12.7" style={{ fontSize: '12.7px'}}> engage in conduct which expresses discriminatory views of any kind against a country, person or </span></span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              group  based  on  race,  skin  colour,  ethnic,  national  or  social  origin,  gender,  disability,  language, </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              religion, political opinion or any other opinion, birth, wealth or any other status, sexual orientation </span>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              or any other grounds, which could impair the enjoyment of the Event by others, or detract from </span>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              the sporting focus of the Event;</span>
          </div>
          <div className="pos" id="_148:17022" style={{top: 17022, left: 148}}>
            <span id="_12.1" style={{ fontSize: '12.1px', color: '#000000'}}>
            •<span id="_13.1" style={{ fontSize: '13.1px'}}> act in a way which may be interpreted by others as provocative, threatening, discriminatory or </span></span>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              offensive;</span>
          </div>
          <div className="pos" id="_148:17057" style={{top: 17057, left: 148}}>
            <span id="_12.1" style={{ fontSize: '12.1px', color: '#000000'}}>
            •<span id="_13.1" style={{ fontSize: '13.1px'}}> offer for sale or sell goods or tickets, distribute printed material or make collections;</span></span>
          </div>
          <div className="pos" id="_148:17075" style={{top: 17075, left: 148}}>
            <span id="_12.1" style={{ fontSize: '12.1px', color: '#000000'}}>
            •<span id="_13.1" style={{ fontSize: '13.1px'}}> create </span><span id="_13.1" style={{ fontSize: '13.1px'}}> any </span><span id="_13.1" style={{ fontSize: '13.1px'}}> threat </span><span id="_13.1" style={{ fontSize: '13.1px'}}> to </span><span id="_13.1" style={{ fontSize: '13.1px'}}> the </span><span id="_13.1" style={{ fontSize: '13.1px'}}> life </span><span id="_13.1" style={{ fontSize: '13.1px'}}> or </span><span id="_13.1" style={{ fontSize: '13.1px'}}> safety </span><span id="_13.1" style={{ fontSize: '13.1px'}}> of </span><span id="_13.1" style={{ fontSize: '13.1px'}}> oneself </span><span id="_13.1" style={{ fontSize: '13.1px'}}> or </span><span id="_13.1" style={{ fontSize: '13.1px'}}> others, </span><span id="_13.1" style={{ fontSize: '13.1px'}}> or </span><span id="_13.1" style={{ fontSize: '13.1px'}}> harm </span><span id="_13.1" style={{ fontSize: '13.1px'}}> anyone </span><span id="_13.1" style={{ fontSize: '13.1px'}}> else </span><span id="_13.1" style={{ fontSize: '13.1px'}}> in </span><span id="_13.1" style={{ fontSize: '13.1px'}}> any </span><span id="_13.1" style={{ fontSize: '13.1px'}}> way </span></span>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              whatsoever;</span>
          </div>
          <div className="pos" id="_148:17109" style={{top: 17109, left: 148}}>
            <span id="_12.1" style={{ fontSize: '12.1px', color: '#000000'}}>
            •<span id="_13.1" style={{ fontSize: '13.1px'}}> cause damage to anyone or anything;</span></span>
          </div>
          <div className="pos" id="_148:17127" style={{top: 17127, left: 148}}>
            <span id="_12.1" style={{ fontSize: '12.1px', color: '#000000'}}>
            •<span id="_13.1" style={{ fontSize: '13.1px'}}> climb </span><span id="_13.1" style={{ fontSize: '13.1px'}}> on </span><span id="_13.1" style={{ fontSize: '13.1px'}}> or </span><span id="_13.1" style={{ fontSize: '13.1px'}}> over </span><span id="_13.1" style={{ fontSize: '13.1px'}}> structures </span><span id="_13.1" style={{ fontSize: '13.1px'}}> and </span><span id="_13.1" style={{ fontSize: '13.1px'}}> installations </span><span id="_13.1" style={{ fontSize: '13.1px'}}> not </span><span id="_13.1" style={{ fontSize: '13.1px'}}> intended </span><span id="_13.1" style={{ fontSize: '13.1px'}}> for </span><span id="_13.1" style={{ fontSize: '13.1px'}}> general </span><span id="_13.1" style={{ fontSize: '13.1px'}}> use, </span><span id="_13.1" style={{ fontSize: '13.1px'}}> particularly </span><span id="_13.1" style={{ fontSize: '13.1px'}}> facades, </span></span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              fences, walls, barriers, lighting masts, camera platforms, trees, masts of any other kind and roofing;</span>
          </div>
          <div className="pos" id="_148:17161" style={{top: 17161, left: 148}}>
            <span id="_12.1" style={{ fontSize: '12.1px', color: '#000000'}}>
            •<span id="_13.1" style={{ fontSize: '13.1px'}}> restrict or impede circulation, footpaths and roadways, entrances and exits to visitor areas and </span></span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              emergency exits, or obstruct or interfere with zones open to traffic;</span>
            •<span id="_12.8" style={{ fontSize: '12.8px'}}> write or paint on or affix anything to structural elements, installations or pathways;</span>
          </div>
          <div className="pos" id="_148:17214" style={{top: 17214, left: 148}}>
            <span id="_12.2" style={{ fontSize: '12.7px', color: '#000000'}}>
            •<span id="_13.2" style={{ fontSize: '13.2px'}}> relieve themselves anywhere other than in the toilets, or litter an Accredited Site by discarding </span></span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              objects such as rubbish, packaging, empty containers, etc.; and/or</span>
          </div>
          <div className="pos" id="_148:17248" style={{top: 17248, left: 148}}>
            <span id="_11.6" style={{ fontSize: '11.6px', color: '#000000'}}>
            •<span id="_12.7" style={{ fontSize: '12.7px'}}> engage in other activities which could compromise public safety and/or harm the reputation of the </span></span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              Event or the Organizer, as assessed at the sole discretion of the Organizer and/or any other duly </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              authorised persons.</span>
          </div>
          <div className="pos" id="_98:17318" style={{top: 17318, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (xi)</span>
          </div>
          <div className="pos" id="_146:17318" style={{top: 17318, left: 146}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              In addition, all Accredited Parties undertake to comply with the relevant Organizer Code of Conduct and </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              the Standards of Conduct Policy and other Accredited Site regulations, policies and procedures for the </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              Event, which can be requested from the Organizer. The Organizer shall have sole discretion in resolving </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              any inconsistency between such other regulations, policies and procedures and these Accreditation T&amp;C.</span>
          </div>
          {/* <div className="pos" id="_0:0" style={{top: 17550}}> */}
            {/* <img name="_1170:828" src="page_016.jpg" height={1170} width={828} border={0} useMap="#Map" /></div> */}
          <div className="pos" id="_28:17566" style={{top: 17566, left: 28}}>
            
          </div>
          <div className="pos" id="_98:17648" style={{top: 17648, left: 98}}>
            <span id="_13.6" style={{fontWeight: 'bold',   color: '#000000'}}>
              7.</span>
          </div>
          <div className="pos" id="_148:17648" style={{top: 17648, left: 148}}>
            <span id="_12.4" style={{fontWeight: 'bold',  fontSize: '12.4px', color: '#000000'}}>
              Image Release</span>
          </div>
          <div className="pos" id="_91:17683" style={{top: 17683, left: 91}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              Any  Accredited  Party  attending  an  Accredited  Site  agrees  that  the  Event  is  a  public  event  and  thus </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              unconditionally  agrees  (to  the  extent  permitted  by  applicable  laws)  that  use  may  be  made  in  perpetuity,  for </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              commercial purposes or otherwise, free of charge or any compensation, of their name, voice, image,  photograph </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              or likeness and other biographical details by means of live or recorded audio/video display,  broadcast, streaming, </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              uploading, posting or other transmission or recording, photographs or any other  current  and/or  future  media </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              technologies  (now  known  or  hereinafter  invented  and/or  devised)  and irrevocably consents to the use of such </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              name, voice, image, photograph or likeness by the Organizer or  third parties authorised by the Organizer to use </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              such media. Each Accredited Party waives in advance all  rights and actions seeking to oppose such use, subject to </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              applicable laws.</span>
          </div>
          <div className="pos" id="_98:17852" style={{top: 17852, left: 98}}>
            <span id="_13.6" style={{fontWeight: 'bold',   color: '#000000'}}>
              8.</span>
          </div>
          <div className="pos" id="_148:17852" style={{top: 17852, left: 148}}>
            <span id="_12.3" style={{fontWeight: 'bold',  fontSize: '14.3px', color: '#000000'}}>
              Sound, Image and Data Recordings</span>
          </div>
          <div className="pos" id="_106:17886" style={{top: 17886, left: 106}}>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              (i) <u>G</u><u>e</u><u>n</u><u>e</u><u>r</u><u>a</u><u>l</u><u> </u><u>P</u><u>r</u><u>o</u><u>h</u><u>i</u><u>b</u><u>i</u><u>t</u><u>i</u><u>o</u><u>n</u></span>
          </div>
          <div className="pos" id="_98:17903" style={{top: 17903, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              8.1.1</span>
          </div>
          <div className="pos" id="_148:17903" style={{top: 17903, left: 148}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              Except  for  photographic  images  for  private  and  non-commercial  use  only,  each  Accredited  Party  is </span>
            <span id="_13.2" style={{ fontSize: '13.2px', color: '#000000'}}>
              prohibited from recording (by means of  any device, including but not limited  to mobile telephones) </span>
            <span id="_13.2" style={{ fontSize: '13.2px', color: '#000000'}}>
              and/or transmitting (over any medium, including but not limited to radio, television, the internet and </span>
            <span id="_13.2" style={{ fontSize: '13.2px', color: '#000000'}}>
              mobile transmission media) any sound (including commentary) and/or image (whether moving or still) </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              of  the  Accredited  Site(s),  attendees  or  any  activity  at  the  Event,  including  of  any  musical/theatrical </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              performances and any Event transmissions made for public viewing reception at the Event (e.g. on the </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              screens), in whole or in part, or from assisting any other person or entity in conducting such activities.</span>
          </div>
          <div className="pos" id="_98:18037" style={{top: 18037, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              8.1.2</span>
          </div>
          <div className="pos" id="_148:18037" style={{top: 18037, left: 148}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              Except for private and non-commercial use only, or except to the extent strictly required in order to fulfil </span>
            <span id="_13.2" style={{ fontSize: '13.2px', color: '#000000'}}>
              the functions that are to be performed during the Event and for which the Accreditation Device has </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              been  issued,  each  Accredited  Party  is  strictly  prohibited  from  recording  (by  means  of  any  device, </span>
            <span id="_13.3" style={{ fontSize: '13.3px', color: '#000000'}}>
              including but not limited to mobile telephones) and/or transmitting (over any medium, including but </span>
            <span id="_13.3" style={{ fontSize: '13.3px', color: '#000000'}}>
              not limited to  radio, television, the  internet and mobile  transmission media), any  description, result </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              and/or  statistics  of  the  Event,  in  whole  or  in  part,  or  from  assisting  any  other  person  or  entity  in </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              conducting such activities.</span>
          </div>
          <div className="pos" id="_98:18171" style={{top: 18171, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              8.1.3</span>
          </div>
          <div className="pos" id="_148:18171" style={{top: 18171, left: 148}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              For the avoidance of doubt, nothing in these Accreditation T&amp;C is intended to be, or shall be interpreted </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              as,  restricting  or  undermining  the  editorial  independence  or  freedom  to  report  and  comment  of </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              Accredited Parties.</span>
          </div>
          <div className="pos" id="_106:18239" style={{top: 18239, left: 106}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              (ii) Media Representatives</span>
          </div>
          <div className="pos" id="_98:18273" style={{top: 18273, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              8.2.1</span>
          </div>
          <div className="pos" id="_148:18273" style={{top: 18273, left: 148}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              <u>P</u><u>r</u><u>i</u><u>n</u><u>t</u><u>e</u><u>d</u><u>,</u><u> </u><u>N</u><u>o</u><u>n</u><u>-</u><u>E</u><u>l</u><u>e</u><u>c</u><u>t</u><u>r</u><u>o</u><u>n</u><u>i</u><u>c</u><u> </u><u>P</u><u>e</u><u>r</u><u>m</u><u>i</u><u>t</u><u>t</u><u>e</u><u>d</u><u> </u><u>P</u><u>u</u><u>b</u><u>l</u><u>i</u><u>c</u><u>a</u><u>t</u><u>i</u><u>o</u><u>n</u><u>s</u></span>
          </div>
          <div className="pos" id="_91:18307" style={{top: 18307, left: 91}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              Notwithstanding  the  general  prohibition  in  Clause  8.1  above,  Media  Representatives  who  are  designated </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              photographic  journalists  may  record  and/or  transmit  still  photographic  images  for publication in printed, hard-</span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              copy non-electronic Permitted Publications, provided that:</span>
          </div>
          <div className="pos" id="_148:18374" style={{top: 18374, left: 148}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (i)</span>
          </div>
          <div className="pos" id="_198:18374" style={{top: 18374, left: 198}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              images are published for editorial news reporting purposes only;</span>
          </div>
          <div className="pos" id="_148:18391" style={{top: 18391, left: 148}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (ii)</span>
          </div>
          <div className="pos" id="_198:18391" style={{top: 18391, left: 198}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              images are not used in commercial association with the names, marks, symbols or logos of any </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              commercial entity; and</span>
          </div>
          <div className="pos" id="_148:18425" style={{top: 18425, left: 148}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (iii)</span>
          </div>
          <div className="pos" id="_198:18425" style={{top: 18425, left: 198}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              no alteration or manipulation is made to or of any published image, which (a) intentionally </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              obscures or removes a sponsor identification image, or (b) adds or overlays onto the image the </span>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              commercial identification of any third party which is not officially associated with the Event. </span>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              Except  as  prohibited  by  the  foregoing,  the  images  may  be  manipulated  by,  for  example, </span>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              cropping,  overlaying  (including  with  copyright  or  photographer  credits),  bleeding  and </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              obscuring parts of the image.</span>
          </div>
          <div className="pos" id="_98:18543" style={{top: 18543, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              8.2.2</span>
          </div>
          <div className="pos" id="_148:18543" style={{top: 18543, left: 148}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              <u>D</u><u>i</u><u>g</u><u>i</u><u>t</u><u>a</u><u>l</u><u> </u><u>P</u><u>e</u><u>r</u><u>m</u><u>i</u><u>t</u><u>t</u><u>e</u><u>d</u><u> </u><u>P</u><u>u</u><u>b</u><u>l</u><u>i</u><u>c</u><u>a</u><u>t</u><u>i</u><u>o</u><u>n</u><u>s</u></span>
          </div>
          <div className="pos" id="_91:18577" style={{top: 18577, left: 91}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              Notwithstanding  the  general  prohibition  in  Clause  8.1  above,  Media  Representatives  who  are  designated </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              photographic  journalists  may  record  and/or  transmit  still  photographic  images  for  publication on or in digital </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              Permitted Publications, provided that:</span>
          </div>
          {/* <div className="pos" id="_0:0" style={{top: 18720}}> */}
            {/* <img name="_1170:828" src="page_017.jpg" height={1170} width={828} border={0} useMap="#Map" /></div> */}
          <div className="pos" id="_28:18736" style={{top: 18736, left: 28}}>
            
          </div>
          <div className="pos" id="_148:18836" style={{top: 18836, left: 148}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (i)</span>
          </div>
          <div className="pos" id="_198:18836" style={{top: 18836, left: 198}}>
            <span id="_12.5" style={{ fontSize: '12.5px', color: '#000000'}}>
              they appear as still images (and are not used in a manner to emulate video, e.g. GIFs of images </span>
            <span id="_12.5" style={{ fontSize: '12.5px', color: '#000000'}}>
              from the same scene);</span>
          </div>
          <div className="pos" id="_148:18870" style={{top: 18870, left: 148}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (ii)</span>
          </div>
          <div className="pos" id="_198:18870" style={{top: 18870, left: 198}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              images are published for editorial news reporting purposes only;</span>
          </div>
          <div className="pos" id="_148:18886" style={{top: 18886, left: 148}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (iii)</span>
          </div>
          <div className="pos" id="_198:18886" style={{top: 18886, left: 198}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              images are not used in commercial association with the names, marks, symbols or logos of any </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              commercial entity; and</span>
          </div>
          <div className="pos" id="_148:18920" style={{top: 18920, left: 148}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (iv)</span>
          </div>
          <div className="pos" id="_198:18920" style={{top: 18920, left: 198}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              no alteration is made to, and no text or image is superimposed over, any published image which </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              (a) intentionally obscures or removes a sponsor identification image, or (b) adds or overlays </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              the commercial identification of any third party which is not officially associated with the Event. </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              Except  as  prohibited  by  the  foregoing,  the  images  may  be  manipulated  by,  for  example, </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              cropping,  overlaying  (including  with  copyright  or  photographer  credits),  bleeding  and </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              obscuring parts of the image.</span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              For the avoidance of doubt, such images may not be exploited in any manner other than for inclusion  in digital </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              Permitted Publications, whether directly to consumers or via operators or other intermediaries, such as, without </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              limitation, via mobile alert services, downloads to mobile devices or MMS messaging.</span>
          </div>
          <div className="pos" id="_98:19106" style={{top: 19106, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              8.2.3</span>
          </div>
          <div className="pos" id="_148:19106" style={{top: 19106, left: 148}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              <u>P</u><u>h</u><u>o</u><u>t</u><u>o</u><u>g</u><u>r</u><u>a</u><u>p</u><u>h</u><u>i</u><u>c</u><u> </u><u>A</u><u>g</u><u>e</u><u>n</u><u>c</u><u>i</u><u>e</u>s</span>
          </div>
          <div className="pos" id="_91:19140" style={{top: 19140, left: 91}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              The provisions of Clauses 8.2.1 and 8.2.2 shall apply to any Media Representative Accredited Party:</span>
          </div>
          <div className="pos" id="_148:19174" style={{top: 19174, left: 148}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (i)</span>
          </div>
          <div className="pos" id="_198:19174" style={{top: 19174, left: 198}}>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              which is engaged in the business of distribution (including without limitation the sale and/or </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              syndication) of photographic images (each a “<span style={{fontWeight: 'bold'}}> Photographic Agency</span> ”); or</span>
          </div>
          <div className="pos" id="_148:19208" style={{top: 19208, left: 148}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (ii)</span>
          </div>
          <div className="pos" id="_198:19208" style={{top: 19208, left: 198}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              which supplies images to any Photographic Agency.</span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              To  this  end,  all  Photographic  Agencies  must,  when  distributing  photographic  images  taken  under  these </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              Accreditation T&amp;C, clearly bring to the attention of their subscribers the terms of this Clause 8.2, and in  particular </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              Clauses 8.2.1 and 8.2.2 above, prior to their subscribers being allowed access to their images and must require their </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              subscribers to accept and fully comply with the provisions of this Clause 8.2 as a  condition  of  accessing  the </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              Photographic  Agency’s  images  taken  under  these  Accreditation  T&amp;C.  All  Photographic Agency images taken </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              under these Accreditation T&amp;C must be accompanied by the  appropriate advisory indicating the restrictions on </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              the use of images contained in these Accreditation  T&amp;C.</span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              In the event that the Organizer notifies a Photographic Agency that any of its subscribers to images taken under </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              these Accreditation T&amp;C has failed to comply with the provisions of this Clause 8.2, the Photographic Agency will </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              be required to notify the relevant subscriber of its infringing activity and shall  require  the  subscriber  to  provide </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              the  Organizer  with  a  written  undertaking  (such  undertaking  to  be  received by the Organizer no more than 24 </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              hours after receipt of the original infringement notification by  the  Photographic  Agency),  pursuant  to  which  the </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              relevant  subscriber  agrees  to  adhere  to  the provisions of these Accreditation T&amp;C. In the event of any failure by </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              any such subscriber to provide the appropriate written undertaking, the Photographic Agency will be required to </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              immediately  cease  the  delivery  of  images  from  the  Accredited  Site(s)  to  the  subscriber  (whether  directly  or </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              indirectly). Any continuing non-compliance by the relevant subscriber may result in legal action being taken against </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              the subscriber.</span>
          </div>
          <div className="pos" id="_98:19563" style={{top: 19563, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              8.2.4</span>
          </div>
          <div className="pos" id="_148:19563" style={{top: 19563, left: 148}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              <u>N</u><u>o</u><u>n</u><u>-</u><u>R</u><u>i</u><u>g</u><u>h</u><u>t</u><u>s</u><u> </u><u>H</u><u>o</u><u>l</u><u>d</u><u>i</u><u>n</u><u>g</u><u> </u><u>B</u><u>r</u><u>o</u><u>a</u><u>d</u><u>c</u><u>a</u><u>s</u><u>t</u><u>e</u><u>r</u><u>s</u><u>,</u><u> </u><u>N</u><u>e</u><u>w</u><u>s</u><u> </u><u>C</u><u>h</u><u>a</u><u>n</u><u>n</u><u>e</u><u>l</u><u>s</u><u> </u><u>a</u><u>n</u><u>d</u><u> </u><u>N</u><u>e</u><u>w</u><u>s</u><u> </u><u>A</u><u>g</u><u>e</u><u>n</u><u>c</u><u>i</u><u>e</u><u>s</u></span>
          <div className="pos" id="_91:19597" style={{top: 19597, left: 91}}>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              Notwithstanding  the  general  prohibition  in  Clause  8.1  above,  a  limited  number  of  non-rights  holding </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              broadcasters, news channels and/or news agencies may be permitted to record and/or transmit sound  and/or </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              moving  images  at  specific  locations  within  an  Accredited  Site,  if  and  strictly  limited  to  the  extent  expressly </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              authorised by the Organizer, it being understood that the Organizer remains free to revoke  such authorisation </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              at  any  time.  The  non-rights  holding  broadcasters  (including  news  channels,  news  agencies  and/or  agencies </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              working  on  behalf  of  Commercial  Affiliates)  are  prohibited  from  recording,  transmitting and/or publishing any </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              sound (including commentary) and/or image from any part of the Event transmission made for public viewing or </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              reception at the Event (e.g. on the screens) and/or from any musical/theatrical performances.</span>
          </div>
         
          <div className="pos" id="_98:20006" style={{top: 20006, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              8.2.5</span>
          </div>
          <div className="pos" id="_148:20006" style={{top: 20006, left: 148}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              <u>S</u><u>e</u><u>c</u><u>u</u><u>r</u><u>e</u><u> </u><u>T</u><u>r</u><u>a</u><u>n</u><u>s</u><u>m</u><u>i</u><u>s</u><u>s</u><u>i</u><u>o</u><u>n</u></span>
          </div>
          <div className="pos" id="_91:20040" style={{top: 20040, left: 91}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              Any  and  all  transmissions  of  images  permitted  under  this  Clause  8.2  shall  be  made  on  a  securely encrypted </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              basis only, so as to prevent unauthorised access, receiving and/or viewing.</span>
          </div>
          <div className="pos" id="_98:20090" style={{top: 20090, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              8.2.6</span>
          </div>
          <div className="pos" id="_148:20090" style={{top: 20090, left: 148}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              <u>U</u><u>s</u><u>e</u><u> </u><u>o</u><u>f</u><u> </u><u>O</u><u>f</u><u>f</u><u>i</u><u>c</u><u>i</u><u>a</u><u>l</u><u> </u><u>M</u><u>a</u><u>r</u><u>k</u><u>s</u></span>
          </div>
          <div className="pos" id="_91:20124" style={{top: 20124, left: 91}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              Media  Representatives  may  only  use  trademarks,  logos,  emblems  and  marks  associated  with  the  Event  in </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              accordance with the guidelines issued by the Organizer, unless otherwise expressly permitted in writing by the </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              Organizer and, notwithstanding the foregoing, for editorial news reporting purposes only.  Media Representatives </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              shall not engage (either by themselves or with any third party) in any marketing, promotional or any other activities </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              associated with the Event which could result in themselves, or any  third party or third party’s products, being </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              associated with the Event, without the prior written approval  of  the  Organizer.  Further,  Media  Representatives </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              shall not use any Permitted Publications, in which images are published in accordance with the provisions of this </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              Clause 8.2, in any manner which could  result in themselves,  or any  third party or  third party’s products,  being </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              associated  with  the  Event, without the prior written approval of the Organizer.</span>
          </div>
          <div className="pos" id="_106:20294" style={{top: 20294, left: 106}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              (iii)<u>M</u><u>e</u><u>d</u><u>i</u><u>a</u><u> </u><u>R</u><u>i</u><u>g</u><u>h</u><u>t</u><u>s</u><u> </u><u>L</u><u>i</u><u>c</u><u>e</u><u>n</u><u>s</u><u>e</u><u>e</u><u>s</u></span>
          </div>
          <div className="pos" id="_91:20328" style={{top: 20328, left: 91}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              Notwithstanding  the  general  prohibition  in  Clause  8.1  above,  the  representatives  of  authorised  Media  Rights </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              Licensees  may  conduct  the  activities  prohibited  under  such  Clause  8.1  above  strictly  limited  to  the  extent </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              expressly  permitted  in  their  agreements  with  the  Organizer  and  other  applicable  documentation issued from </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              time to time by the Organizer with respect to the terms and conditions applying to the use of sound and images </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              from the Event.</span>
          </div>
          <div className="pos" id="_106:20429" style={{top: 20429, left: 106}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              (iv)<u>I</u><u>m</u><u>a</u><u>g</u><u>e</u><u> </u><u>R</u><u>i</u><u>g</u><u>h</u><u>t</u><u>s</u></span>
          </div>
          <div className="pos" id="_91:20463" style={{top: 20463, left: 91}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              Nothing in these Accreditation T&amp;C grants any right or consent on behalf of any person appearing in any image taken </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              by Accredited Parties at the Accredited Site(s) where such activity is permitted under this Clause 8, and Accredited </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              Parties are responsible for determining whether they require any such rights and consents from any such persons </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              and for obtaining any such rights and consents.</span>
          </div>
          <div className="pos" id="_98:20548" style={{top: 20548, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (v)</span>
          </div>
          <div className="pos" id="_146:20548" style={{top: 20548, left: 146}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              Third Party Rights</span>
          </div>
          <div className="pos" id="_91:20565" style={{top: 20565, left: 91}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              The Accredited Party shall be solely responsible, as its own cost and expenses, for obtaining any and all  relevant </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              rights clearances, permits and consents of any nature whatsoever (including, without limitation,  those  related  to: </span>
          </div>
          <div className="pos" id="_91:20599" style={{top: 20599, left: 91}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              (i)  image  rights:  (ii)  copyrights  in  any  music  or  image  performed,  played  and/or  displayed at the Event; and </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              (iii) any performer’s rights regarding any performance at the Event (in respect  of its recording, transmission and/or </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              publication of any sound and/or image (whether moving or still) on the Event.</span>
          </div>
          <div className="pos" id="_106:20668" style={{top: 20668, left: 106}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              (vi) <u>A</u><u>s</u><u>s</u><u>i</u><u>g</u><u>n</u><u>m</u><u>e</u><u>n</u><u>t</u><u> </u><u>o</u><u>f</u><u> </u><u>I</u><u>n</u><u>t</u><u>e</u><u>l</u><u>l</u><u>e</u><u>c</u><u>t</u><u>u</u><u>a</u><u>l</u><u> </u><u>P</u><u>r</u><u>o</u><u>p</u><u>e</u><u>r</u><u>t</u><u>y</u></span>
          </div>
          <div className="pos" id="_91:20702" style={{top: 20702, left: 91}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              All copyright, database rights and any other intellectual property rights in any recording and/or  transmission that </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              is not expressly permitted under these Accreditation T&amp;C are assigned (by way of present assignment of future </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              rights) to the Organizer. Any such person to whom these Accreditation T&amp;C apply shall (if and whenever required </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              to do so by the Organizer) promptly execute all instruments and do all things necessary to vest the right, title and </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              interest in such rights to the Organizer absolutely  and free of all encumbrances and other charges.</span>
          </div>
          <div className="pos" id="_98:20803" style={{top: 20803, left: 98}}>
            <span id="_13.6" style={{fontWeight: 'bold',   color: '#000000'}}>
              9.</span>
          </div>
          <div className="pos" id="_148:20803" style={{top: 20803, left: 148}}>
            <span id="_12.2" style={{fontWeight: 'bold',  fontSize: '12.7px', color: '#000000'}}>
              Consequences of a Breach of these Accreditation T&amp;C</span>
          </div>
          <div className="pos" id="_98:20837" style={{top: 20837, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (i)</span>
          </div>
          <div className="pos" id="_146:20837" style={{top: 20837, left: 146}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              Any Accredited Party whose actions are inconsistent with, or whose Accreditation Device has not been </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              obtained  in  accordance  with,  these  Accreditation  T&amp;C,  will  be  refused  entry  to  any  Accredited  Site </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              and/or Zone or will be expelled from any Accredited Site and/or Zone which they have accessed for the </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              Event, and the relevant Accreditation Device will be confiscated.</span>
          </div>
          <div className="pos" id="_98:21159" style={{top: 21159, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (ii)</span>
          </div>
          <div className="pos" id="_146:21159" style={{top: 21159, left: 146}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              Where the Organizer has reasonable grounds to believe that an Accredited Party has not complied with </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              these  Accreditation  T&amp;C,  the  Accreditation  Device  of  such  Accredited  Party  will  be  confiscated  and </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              rendered invalid.</span>
          </div>
          <div className="pos" id="_98:21226" style={{top: 21226, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (iii)</span>
          </div>
          <div className="pos" id="_146:21226" style={{top: 21226, left: 146}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              It is not possible to reapply for Accreditation once it has been withdrawn.</span>
          </div>
          <div className="pos" id="_98:21260" style={{top: 21260, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (iv)</span>
          </div>
          <div className="pos" id="_146:21260" style={{top: 21260, left: 146}}>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              The Organizer reserve the right to pursue other legal remedies against any such Accredited Party at </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              its/their sole discretion. The Organizer reserve all other rights against the Accredited Party.</span>
          </div>
          <div className="pos" id="_98:21311" style={{top: 21311, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (v)</span>
          </div>
          <div className="pos" id="_146:21311" style={{top: 21311, left: 146}}>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              Without prejudice to the provisions of Clause 9.4 above, the Organizer reserve the right to impose a </span>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              reasonable financial penalty on any Accredited Party in respect of any breach of these Accreditation </span>
            <span id="_13.6" style={{  color: '#000000'}}>
              T&amp;C.</span>
          </div>
          <div className="pos" id="_98:21379" style={{top: 21379, left: 98}}>
            <span id="_13.6" style={{fontWeight: 'bold',   color: '#000000'}}>
              10.</span>
          </div>
          <div className="text-sm-letter">
          <div className="pos" id="_148:21379" style={{top: 21379, left: 148}}>
            <span id="_12.5" style={{fontWeight: 'bold',  fontSize: '12.5px', color: '#000000'}}>
              Indemnification</span>
          </div>
          <div className="pos" id="_91:21413" style={{top: 21413, left: 91}}>
            <span id="_12.0" style={{ fontSize: '12.7px', color: '#000000'}}>
              ACCREDITED PARTIES ARE RESPONSIBLE FOR THE USE OF ALL ACCREDITATION DEVICES ALLOCATED TO THEM AND </span>
            <span id="_12.0" style={{ fontSize: '12.7px', color: '#000000'}}>
              SHALL INDEMNIFY AND HOLD THE ORGANIZER HARMLESS FROM AND AGAINST ALL  DAMAGES  AND  LIABILITIES </span>
            <span id="_12.0" style={{ fontSize: '12.7px', color: '#000000'}}>
              SUFFERED  OR  INCURRED  IN  CONNECTION  WITH  THE  ALLOCATED  ACCREDITATION DEVICES OR ARISING OUT OF </span>
            <span id="_12.0" style={{ fontSize: '12.7px', color: '#000000'}}>
              A DISREGARD FOR THESE ACCREDITATION T&amp;C.</span>
          </div>
          </div>
          <div className="pos" id="_98:21497" style={{top: 21497, left: 98}}>
            <span id="_13.6" style={{fontWeight: 'bold',   color: '#000000'}}>
              11.</span>
          </div>
          <div className="pos" id="_148:21497" style={{top: 21497, left: 148}}>
            <span id="_12.4" style={{fontWeight: 'bold',  fontSize: '12.4px', color: '#000000'}}>
              Data Protection</span>
          </div>
          <div className="pos" id="_91:21531" style={{top: 21531, left: 91}}>
            <span id="_12.4" style={{ fontSize: '12.4px', color: '#000000'}}>
              Applicants  shall  read  the  organizer  Privacy  Policy  carefully  and  ensure  they  understand  it,  available  at  the </span>
            <span id="_12.4" style={{ fontSize: '12.4px', color: '#000000'}}>
              Organizer website.</span>
          </div>
          <div className="pos" id="_98:21582" style={{top: 21582, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (i)</span>
          </div>
          <div className="pos" id="_146:21582" style={{top: 21582, left: 146}}>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              By submitting an Application Form, Applicants authorise the Organizer to store, transfer and otherwise </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              use any Personal Data provided by Applicants in the Application Form as set out below.</span>
          </div>
          <div className="pos" id="_98:21633" style={{top: 21633, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (ii)</span>
          </div>
          <div className="pos" id="_146:21633" style={{top: 21633, left: 146}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              <u>C</u><u>o</u><u>l</u><u>l</u><u>e</u><u>c</u><u>t</u><u>i</u><u>o</u><u>n</u><u> </u><u>o</u><u>f</u><u> </u><u>P</u><u>e</u><u>r</u><u>s</u><u>o</u><u>n</u><u>a</u><u>l</u><u> </u><u>D</u><u>a</u><u>t</u><u>a</u></span>
          </div>
          <div className="pos" id="_91:21667" style={{top: 21667, left: 91}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              	SC collects the Personal Data provided by the Applicant in the Application Form and processes the same in accordance with the SC Privacy Policy.</span>
          </div>
          <div className="pos" id="_98:21701" style={{top: 21701, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (iii)</span>
          </div>
          <div className="pos" id="_146:21701" style={{top: 21701, left: 146}}>
            <span id="_12.5" style={{ fontSize: '12.5px', color: '#000000'}}>
              <u>P</u><u>u</u><u>r</u><u>p</u><u>o</u><u>s</u><u>e</u><u> </u><u>o</u><u>f</u><u> </u><u>P</u><u>r</u><u>o</u><u>c</u><u>e</u><u>s</u><u>s</u><u>i</u><u>n</u><u>g</u><u> </u><u>a</u><u>n</u><u>d</u><u> </u><u>U</u><u>s</u><u>e</u><u> </u><u>o</u><u>f</u><u> </u><u>P</u><u>e</u><u>r</u><u>s</u><u>o</u><u>n</u><u>a</u><u>l</u><u> </u><u>D</u><u>a</u><u>t</u><u>a</u></span>
          </div>
          <div className="pos" id="_91:21735" style={{top: 21735, left: 91}}>
            <span id="_12.5" style={{ fontSize: '12.5px', color: '#000000'}}>
              The Organizer may use the Personal Data as follows:</span>
          </div>
          <div className="pos" id="_148:21769" style={{top: 21769, left: 148}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (i)</span>
          </div>
          <div className="pos" id="_197:21769" style={{top: 21769, left: 197}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              to process Application Forms and issue Accreditation Devices;</span>
          </div>
          <div className="pos" id="_148:21785" style={{top: 21785, left: 148}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (ii)</span>
          </div>
          <div className="pos" id="_198:21785" style={{top: 21785, left: 198}}>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              subject  to  local  laws  and  to  the  extent  applicable  to  the  Applicant,  to  facilitate  expedited </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              procedures for entry and exit to and from the Host Country and exemptions from obligations </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              to obtain work permits;</span>
          </div>
          <div className="pos" id="_148:21837" style={{top: 21837, left: 148}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (iii)</span>
          </div>
          <div className="pos" id="_197:21837" style={{top: 21837, left: 197}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              to carry out the access check procedure;</span>
          </div>
          <div className="pos" id="_148:21853" style={{top: 21853, left: 148}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (iv)</span>
          </div>
          <div className="pos" id="_197:21853" style={{top: 21853, left: 197}}>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              to confirm, as part of Workers' Welfare monitoring activities, the presence of workers at an </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              Accredited Site; and</span>
          </div>
          <div className="pos" id="_148:21887" style={{top: 21887, left: 148}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (v)</span>
          </div>
          <div className="pos" id="_197:21887" style={{top: 21887, left: 197}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              To carry out other necessary health, security and/or background checks.</span>
          </div>
          <div className="pos" id="_91:21921" style={{top: 21921, left: 91}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              The Organizer will comply with the obligations and safeguard the Applicant’s rights under the Applicable Data </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              Protection Laws.</span>
          </div>
          <div className="pos" id="_91:21972" style={{top: 21972, left: 91}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              The Organizer will process and store the Personal Data securely and for no longer than is necessary for  the </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              purposes for which it was first collected.</span>
          </div>
          <div className="pos" id="_98:22023" style={{top: 22023, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (iv)</span>
          </div>
          <div className="pos" id="_146:22023" style={{top: 22023, left: 146}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              <u>S</u><u>h</u><u>a</u><u>r</u><u>i</u><u>n</u><u>g</u><u> </u><u>P</u><u>e</u><u>r</u><u>s</u><u>o</u><u>n</u><u>a</u><u>l</u><u> </u><u>D</u><u>a</u><u>t</u><u>a</u><u> </u><u>w</u><u>i</u><u>t</u><u>h</u><u> </u><u>T</u><u>h</u><u>i</u><u>r</u><u>d</u><u> </u><u>P</u><u>a</u><u>r</u><u>t</u><u>i</u><u>e</u><u>s</u></span>
          </div>
          <div className="pos" id="_91:22056" style={{top: 22056, left: 91}}>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              In this regard, Applicants acknowledge and agree that such Personal Data may be transferred to public authorities </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              and/or  authorised  bodies  and  organisations  as  may  be  required  under  the  applicable  national  laws  and/or </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              for security reasons. The Personal Data will not be used, processed, stored or transmitted by the Organizer over </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              and above the scope described herein.</span>
          </div>
          {/* <div className="pos" id="_0:0" style={{top: 22230}}> */}
            {/* <img name="_1170:828" src="page_020.jpg" height={1170} width={828} border={0} useMap="#Map" /></div> */}
          <div className="pos" id="_28:22246" style={{top: 22246, left: 28}}>
            
          </div>
          <div className="pos" id="_98:22346" style={{top: 22346, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (v)</span>
          </div>
          <div className="pos" id="_146:22346" style={{top: 22346, left: 146}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              <u>A</u><u>p</u><u>p</u><u>l</u><u>i</u><u>c</u><u>a</u><u>n</u><u>t</u><u>’</u><u>s</u><u> </u><u>R</u><u>i</u><u>g</u><u>h</u><u>t</u><u>s</u></span>
          </div>
          <div className="pos" id="_91:22380" style={{top: 22380, left: 91}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              The Applicant has the following rights under the Applicable Data Protection Laws, which this Clause 11 adheres to:</span>
          </div>
          <div className="pos" id="_148:22413" style={{top: 22413, left: 148}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (i)</span>
          </div>
          <div className="pos" id="_197:22413" style={{top: 22413, left: 197}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              the right to be informed about the collection and use of the Personal Data;</span>
          </div>
          <div className="pos" id="_148:22430" style={{top: 22430, left: 148}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (ii)</span>
          </div>
          <div className="pos" id="_197:22430" style={{top: 22430, left: 197}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              the right to access and receive a copy of the Personal Data that the Organizer holds about the </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              Applicant;</span>
          </div>
          <div className="pos" id="_148:22464" style={{top: 22464, left: 148}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (iii)</span>
          </div>
          <div className="pos" id="_197:22464" style={{top: 22464, left: 197}}>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              the right to rectification if any Personal Data that the Organizer holds about the Applicant is </span>
            <span id="_13.0" style={{ fontSize: '13.8px', color: '#000000'}}>
              inaccurate or incomplete;</span>
          </div>
          <div className="pos" id="_148:22498" style={{top: 22498, left: 148}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (iv)</span>
          </div>
          <div className="pos" id="_197:22498" style={{top: 22498, left: 197}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              the right to ask the Organizer to delete any Personal Data that the Organizer holds about the </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              Applicant and/or to delete it sooner than indicated in Clause 11.3 above;</span>
          </div>
          <div className="pos" id="_148:22531" style={{top: 22531, left: 148}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (v)</span>
          </div>
          <div className="pos" id="_197:22531" style={{top: 22531, left: 197}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              the right to restrict (i.e. prevent) the processing of the Personal Data;</span>
          </div>
          <div className="pos" id="_148:22548" style={{top: 22548, left: 148}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (vi)</span>
          </div>
          <div className="pos" id="_197:22548" style={{top: 22548, left: 197}}>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              the right to data portability (i.e. obtaining a copy of the Personal Data to re-use with another </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              service or organisation);</span>
          </div>
          <div className="pos" id="_148:22582" style={{top: 22582, left: 148}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (vii)</span>
          </div>
          <div className="pos" id="_197:22582" style={{top: 22582, left: 197}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              the right to object the Organizer using the Personal Data for particular purposes; and</span>
          </div>
          <div className="pos" id="_148:22599" style={{top: 22599, left: 148}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (viii)</span>
          </div>
          <div className="pos" id="_197:22599" style={{top: 22599, left: 197}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              rights with respect to automated decision-making and profiling.</span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              In the event of any cause for complaint about the use of the Personal Data or if the Applicant has any  questions </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              relating to this Clause 11, the Applicant shall contact the Organizer. The Organizer shall apply  its  best  efforts  to </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              solve the problem for the Applicant. The Applicant also has the right to lodge a  complaint with the competent </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              data protection supervisory authorities.</span>
          </div>
          <div className="pos" id="_98:22736" style={{top: 22736, left: 98}}>
            <span id="_13.6" style={{fontWeight: 'bold',   color: '#000000'}}>
              12.</span>
          </div>
          <div className="pos" id="_148:22736" style={{top: 22736, left: 148}}>
            <span id="_12.3" style={{fontWeight: 'bold',  fontSize: '14.3px', color: '#000000'}}>
              Unforeseen Circumstances</span>
          </div>
          <div className="pos" id="_91:22770" style={{top: 22770, left: 91}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              The Organizer reserve(s) the right to make alterations to the location of any Accredited Site, or the time,  date and </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              place of access to any Accredited Site, due to unforeseen circumstances. Such circumstances  include, without </span>
          </div>
          <div className="pos" id="_91:22804" style={{top: 22804, left: 91}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              limitation, force majeure, safety and security concerns or decisions of any competent authority.</span>
          </div>
          <div className="pos" id="_98:22838" style={{top: 22838, left: 98}}>
            <span id="_13.6" style={{fontWeight: 'bold',   color: '#000000'}}>
              13.</span>
          </div>
          <div className="pos" id="_148:22838" style={{top: 22838, left: 148}}>
            <span id="_12.3" style={{fontWeight: 'bold',  fontSize: '14.3px', color: '#000000'}}>
              Point of Contact</span>
          </div>
          <div className="pos" id="_91:22872" style={{top: 22872, left: 91}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              Any request pursuant to these Accreditation T&amp;C shall be made to the Organizer.</span>
          </div>
          <div className="pos" id="_98:22905" style={{top: 22905, left: 98}}>
            <span id="_13.6" style={{fontWeight: 'bold',   color: '#000000'}}>
              14.</span>
          </div>
          <div className="pos" id="_148:22905" style={{top: 22905, left: 148}}>
            <span id="_12.4" style={{fontWeight: 'bold',  fontSize: '12.4px', color: '#000000'}}>
              Severability and Amendments</span>
          </div>
          <div className="pos" id="_98:22939" style={{top: 22939, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (i)</span>
          </div>
          <div className="pos" id="_146:22939" style={{top: 22939, left: 146}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              In the event that any provision of these Accreditation T&amp;C is declared void, ineffective or unenforceable </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              by any competent court, the validity of the remaining provisions of these Accreditation T&amp;C shall remain </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              unaffected.  To  the  maximum  extent  permitted  under  applicable  law,  the  void,  ineffective  or </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              unenforceable  provision  shall  be  replaced  automatically  by  a  valid  and  enforceable  provision  whose </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              effect  comes  as  close  as  possible  to  the  intended  purpose  of  the  void,  ineffective  or  unenforceable </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              provision.</span>
          </div>
          <div className="pos" id="_98:23057" style={{top: 23057, left: 98}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (ii)</span>
          </div>
          <div className="pos" id="_146:23057" style={{top: 23057, left: 146}}>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              Without  indicating  the  reasons  for  doing  so,  the  Organizer  reserves  the  right  to  make  reasonable </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              amendments  to  these  Accreditation  T&amp;C.  Updated  versions  shall  be  available  on  Organizer’s </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              accreditation portal. It is the responsibility of the Accredited Party to ensure that they have read the </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              latest version of these Accreditation T&amp;C and the Accredited Party’s continued use of the Accreditation </span>
            <span id="_12.8" style={{ fontSize: '13.8px', color: '#000000'}}>
              Device is in acceptance and agreement with the updated Accreditation T&amp;C.</span>
          </div>
          <div className="pos" id="_98:23159" style={{top: 23159, left: 98}}>
            <span id="_13.6" style={{fontWeight: 'bold',   color: '#000000'}}>
              15.</span>
          </div>
          <div className="pos" id="_146:23159" style={{top: 23159, left: 146}}>
            <span id="_12.4" style={{fontWeight: 'bold',  fontSize: '12.4px', color: '#000000'}}>
              Authentic Text</span>
          </div>
          <div className="pos" id="_91:23194" style={{top: 23194, left: 91}}>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              Although these Accreditation T&amp;C may have been made available in multiple languages on the various Organizer </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              platforms, the English version shall prevail in the event of any dispute or in the event of any  conflict or ambiguity </span>
            <span id="_12.9" style={{ fontSize: '12.9px', color: '#000000'}}>
              between the different versions.</span>
          </div>
          <div className="pos" id="_107:23504" style={{top: 23504, left: 107}}>
            <span id="_13.6" style={{fontWeight: 'bold',   color: '#000000'}}>
              16.</span>
          </div>
          <div className="pos" id="_154:23504" style={{top: 23504, left: 154}}>
            <span id="_12.2" style={{fontWeight: 'bold',  fontSize: '12.7px', color: '#000000'}}>
              Places of Jurisdiction and Governing Law</span>
          </div>
          <div className="pos" id="_107:23538" style={{top: 23538, left: 107}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (i)</span>
          </div>
          <div className="pos" id="_154:23538" style={{top: 23538, left: 154}}>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              To the fullest extent permitted under applicable laws and subject to Clause 11 above, these Accreditation </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              T&amp;C shall be governed by the substantive laws of Qatar. For all disputes regarding and in connection </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              with any rights and obligations deriving from these Accreditation T&amp;C, the parties will seek to resolve </span>
            <span id="_12.7" style={{ fontSize: '12.7px', color: '#000000'}}>
              such  dispute  amicably.  In  case  of  failure  to  reach  such  an  amicable  solution,  the  exclusive  places  of </span>
            <span id="_13.2" style={{ fontSize: '13.2px', color: '#000000'}}>
              jurisdiction to resolve any dispute shall be the courts of Doha, Qatar (excluding the courts within the </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              Qatar Financial Centre).</span>
          </div>
          <div className="pos" id="_107:23656" style={{top: 23656, left: 107}}>
            <span id="_13.6" style={{  color: '#000000'}}>
              (ii)</span>
          </div>
          <div className="pos" id="_154:23656" style={{top: 23656, left: 154}}>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              Irrespective hereof and subject to applicable laws, the Organizer reserves the right to bring any legal </span>
            <span id="_13.1" style={{ fontSize: '13.1px', color: '#000000'}}>
              action  in  relation  to  these  Accreditation  T&amp;C  in  the  local  court  of  the  domicile  or  residence  of  the </span>
            <span id="_12.6" style={{ fontSize: '12.6px', color: '#000000'}}>
              Accredited Party.</span>
          </div>
          
          <div className="pos my-3 text-center" id="_389:24601" style={{top: 24601, left: 389}}>
            <span id="_18.5" style={{fontWeight: 'bold',  fontSize: '18.5px', color: '#000000'}}>
              Appendix 3</span>
          </div>
          <div className="pos" id="_357:24632" style={{top: 24632, left: 357}}>
            <span id="_18.5" style={{fontWeight: 'bold',  fontSize: '18.5px', color: '#000000'}}>
              Filming Permit Terms</span>
          </div>
          <div className="pos" id="_100:24695" style={{top: 24695, left: 100}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000000'}}>
              1. Any Filming Permit granted pursuant to these T&amp;Cs will allow filming/ photography across the State </span>
          </div>
          <div className="pos" id="_125:24715" style={{top: 24715, left: 125}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000000'}}>
              of Qatar, except for the following locations:</span>
          </div>
          <div className="pos" id="_125:24735" style={{top: 24735, left: 125}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000000'}}>
              a) Barracks and Military Bases</span>
          </div>
          <div className="pos" id="_125:24755" style={{top: 24755, left: 125}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000000'}}>
              b) Security or police buildings</span>
          </div>
          <div className="pos" id="_125:24775" style={{top: 24775, left: 125}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000000'}}>
              c) Chancelleries</span>
          </div>
          <div className="pos" id="_125:24795" style={{top: 24795, left: 125}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000000'}}>
              d) All borders (land, sea and aerial)</span>
          </div>
          <div className="pos" id="_125:24816" style={{top: 24816, left: 125}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000000'}}>
              e) Residential properties, private businesses and industrial zones</span>
          </div>
          <div className="pos" id="_100:24856" style={{top: 24856, left: 100}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000000'}}>
              2. Filming is prohibited inside the following:</span>
          </div>
          <div className="pos" id="_125:24876" style={{top: 24876, left: 125}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000000'}}>
              a) Governmental, educational, health institutions and places of worship</span>
          </div>
          <div className="pos" id="_125:24896" style={{top: 24896, left: 125}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000000'}}>
              b) Restricted areas where filming requires prior permission</span>
          </div>
          <div className="pos" id="_125:24916" style={{top: 24916, left: 125}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000000'}}>
              c) Any site with signage or security advising of no photography/videography</span>
          </div>
          <div className="pos" id="_100:24956" style={{top: 24956, left: 100}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000000'}}>
              3. A filming Permits does not allow filming with drones.</span>
          </div>
          <div className="pos" id="_100:24997" style={{top: 24997, left: 100}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000000'}}>
              4. By submitting this form, you/ your organization agree to the following terms:</span>
          </div>
          <div className="pos" id="_125:25017" style={{top: 25017, left: 125}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000000'}}>
              a) Only capture film/ photography at permitted locations</span>
          </div>
          <div className="pos" id="_125:25037" style={{top: 25037, left: 125}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000000'}}>
              b) Not to capture film/ photography at the excluded locations listed above</span>
          </div>
          <div className="pos" id="_125:25057" style={{top: 25057, left: 125}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000000'}}>
              c) Respect the privacy of individuals &amp; to not intrude on their personal lives or film them or their </span>
          </div>
          <div className="pos" id="_150:25077" style={{top: 25077, left: 150}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000000'}}>
              properties without their express prior approval</span>
          </div>
          <div className="pos" id="_125:25097" style={{top: 25097, left: 125}}>
            <span id="_14.2" style={{ fontSize: '14.2px', color: '#000000'}}>
              d) To comply with Qatari laws</span>
          </div>
        </div>
      </div>
      </div>
      {/* <CountdownBar /> */}
    </>
  );
}

Terms.getLayout = function getLayout(page) {
  return (
    <Layout>
      <Nav />
      {page}
      <Footer />
    </Layout>
  );
};

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}
